import axios from 'axios';
// import _ from "lodash"
import eventsOddsHandler from '@/services/eventsOddsHandler';
import rulesHandler from '@/services/rulesHandler';

import filter from 'lodash/filter';
import forEachLodash from 'lodash/forEach';
import findLodash from 'lodash/find';
import findIndex from 'lodash/findIndex';
import last from 'lodash/last';
import assign from 'lodash/assign';
import size from 'lodash/size';
import isEmpty from 'lodash/isEmpty';
import orderBy from 'lodash/orderBy';
import remove from 'lodash/remove';

const FOOTBALL_SPORT_ID = 8412615417;
const DEFINED_ODDS_STATUS = 3;

const state = {
  first_loading: true,
  loading_preview: false,
  loading_general: false,
  loading_live: false,
  loading_detail: false,
  preview: [],
  count_live: [],
  preview_live: [],
  live_mode: 'preview',
  tournaments_active: [],
  events_detail: [],
  events_detail_active: [],
  events_live_detail: [],
  events_live_detail_active: [],
  count_next_events: [],
  count_events_day: [],
  preview_next_events: [],
  preview_events_day: [],
  preview_events_best_played: [],
  count_events_best_played: [],
  live_sport_selected: {},
  cashout: {},
  daySkip: 0,
  dayLimit: 5,
  event_statscore: false,
  prematch_statscore: false,
  odds_type: 'decimal',
  configuredGroupsMarkets: [],
  marketsGroupsIdActive: [],
  marketsIdActive: [],
  previewTabsSelectedForTournament: [],
  nextEventModuleSelected: 'widget', // widget - normal
  marketsGroupsDetailPrematch: [],
  marketsGroupsDetailLive: [],
  featuredTournaments: [],
  featuredTournamentsSourcesActive: [],
  isFirstLoadForFeaturedTournament: true,
  viewLiveMatchTracker: true,
  hideBestPlayedWidget: false
};

const getters = {
  getDaySkip: state => {
    return state.daySkip;
  },
  getDayLimit: state => {
    return state.dayLimit;
  },
  getLoadingPreview: state => {
    return state.loading_preview;
  },
  getFirstLoading: state => {
    return state.first_loading;
  },
  getLoadingGeneral: state => {
    return state.loading_general;
  },
  getLiveSportSelected: state => {
    return state.live_sport_selected;
  },
  getLoadingLive: state => {
    return state.loading_live;
  },
  getLiveMode: state => {
    return state.live_mode;
  },
  getLoadingDetail: state => {
    return state.loading_detail;
  },
  getPreview: state => {
    return state.preview;
  },
  getPreviewLive: state => {
    return state.preview_live;
  },
  getCountLive: state => {
    return state.count_live;
  },
  getTournamentsActive: state => {
    return state.tournaments_active;
  },
  getEventsDetail: state => {
    return state.events_detail;
  },
  getEventsLiveDetail: state => {
    return state.events_live_detail;
  },
  getEventsLiveDetailActive: state => {
    return state.events_live_detail_active;
  },
  // getEventsPrematchDetail: state => {
  //     return state.events_prematch_detail;
  // },
  getEventsDetailActive: state => {
    return state.events_detail_active;
  },
  getNextEvents: state => {
    return state.preview_next_events;
  },
  getEventsDay: state => {
    return state.preview_events_day;
  },
  getEventsBestPlayed: state => {
    return state.preview_events_best_played;
  },
  getCountEventsBestPlayed: state => {
    return state.count_events_best_played;
  },
  getCountNextEvents: state => {
    return state.count_next_events;
  },
  getCountEventsDay: state => {
    return state.count_events_day;
  },
  getEventStatscore: state => {
    return state.event_statscore;
  },
  getConfiguredGroupsMarkets: state => {
    return state.configuredGroupsMarkets;
  },
  getMarketsGroupsIdActive: state => {
    return state.marketsGroupsIdActive;
  },
  getMarketsIdActive: state => {
    return state.marketsIdActive;
  },
  getPrematchEventStatscore: state => {
    return state.prematch_statscore;
  },
  getOddsType: state => {
    return state.odds_type;
  },
  getPreviewTabsSelectedForTournament: state => {
    return state.previewTabsSelectedForTournament;
  },
  getNextEventModuleSelected: state => {
    return state.nextEventModuleSelected;
  },
  getMarketsGroupsDetailPrematch: state => {
    return state.marketsGroupsDetailPrematch;
  },
  getMarketsGroupsDetailLive: state => {
    return state.marketsGroupsDetailLive;
  },
  getFeaturedTournaments: state => {
    return state.featuredTournaments;
  },
  getFeaturedTournamentsSourcesActive: state => {
    return state.featuredTournamentsSourcesActive;
  },
  getIsFirstLoadForFeaturedTournament: state => {
    return state.isFirstLoadForFeaturedTournament;
  },
  getViewLiveMatchTracker: state => {
    return state.viewLiveMatchTracker;
  },
  getHideBestPlayedWidget: state => {
    return state.hideBestPlayedWidget;
  }
};

const actions = {
  async getEventIdLiveTracker(context, payload) {
    // console.log("payload in getEventIdLiveTracker action")
    // console.log(payload)

    const matchId = payload.matchId;
    const sport = payload.sport;

    // const url = `${context.rootGetters['settings/getUrlApi']}/sports/livematch-tracker/` + matchid + `/` + sport ;
    const url =
      `${context.rootGetters['settings/getUrlApi']}/sports/livematch-tracker/sport/${sport}/event/` +
      matchId;

    return await axios.get(url, {
      headers: {
        Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
      }
    });
  },

  async updateLiveCount(context, payload) {
    const checkSport = findLodash(context.state.count_live, {
      _id: payload.event.sport._id
    });
    //console.log("CHECK SPORT",checkSport)
    //console.log("PAYLOAD",payload)
    if (checkSport) {
      if (checkSport.selected == true) {
        const onlyManager = context.rootGetters['settings/getPlatformId'] == 0;
        const rules = {
          manager: context.rootGetters['rules/getRulesManager'],
          skin: !onlyManager ? context.rootGetters['rules/getRulesSkin'] : [],
          lang: context.rootGetters['settings/getLanguage']
        };

        // ToDo Live Switch
        const producer = 0;

        const eventRefactored = await eventsOddsHandler.refactorSingleLive(
          payload.event,
          rules,
          producer,
          onlyManager,
          payload.settings
        );
        if (eventRefactored != false) {
          checkSport.count++;
          context.commit('ADD_PREVIEW_LIVE', eventRefactored);
        }
      } else {
        if (checkSport.events) {
          const eventObj = {
            id: payload.event.id,
            categoryId: payload.event.category.id,
            tournamentId: payload.event.tournament.id
          };
          checkSport.events.push(eventObj);
          checkSport.events.count++;
        }
      }
    } else {
      const eventObj = {
        id: payload.event.id,
        categoryId: payload.event.category.id,
        tournamentId: payload.event.tournament.id
      };

      const sportObj = {
        _id: payload.event.sport._id,
        count: 1,
        sport: payload.event.sport,
        events: [eventObj]
        // settings: payload.settings
      };

      context.state.count_live.push(sportObj);
    }
  },
  async updateLivescore(context, payload) {
    forEachLodash(payload, async change => {
      const id_event = change.id;
      const livescore = last(change.livescore);

      //realtime my bets aggiornamento livescore
      if (context.rootGetters['user/getDetailMyBets']) {
        // console.log(context.rootGetters['user/getDetailMyBets']);
        // console.log(payload)

        const clone = { ...context.rootGetters['user/getDetailMyBets'] };
        var check = findLodash(clone.odds, { event_source: id_event });
        if (check) {
          // console.log('Check: ', check, livescore);

          check.result_actual = livescore.Scoreboard.Results;
          check.time_actual = livescore.Scoreboard.Time / 60;

          check.result_actual_home = await eventsOddsHandler.getResult(
            check.result_actual,
            'home'
          );
          check.result_actual_away = await eventsOddsHandler.getResult(
            check.result_actual,
            'away'
          );

          // context.rootState['user/getDetailMyBets'] = clone
          context.commit('user/SET_DETAIL_MY_BETS', clone, { root: true });
        }
      }

      if (livescore.Scoreboard.Status == 3) {
        let find = false;
        let index = -1;
        let indexSport = -1;

        forEachLodash(context.state.count_live, (sport, idx) => {
          const check = findIndex(sport.events, { id: id_event });
          if (check != -1) {
            index = check;
            find = sport;
            indexSport = idx;
          }
        });

        if (find) {
          find.count--;
          find.events.splice(index, 1);
          if (find.count == 0) {
            context.state.count_live.splice(indexSport, 1);
          }
        }
      }

      if (context.state.preview_live.length > 0) {
        var check = findLodash(context.state.preview_live, events => {
          return events.events_sources.includes(+id_event);
        });

        if (check) {
          forEachLodash(check.events, event => {
            if (event.id == +id_event) {
              if (event.livescore == undefined) {
                event.livescore = livescore;
              } else if (
                check.sport.id == 8412615417 &&
                +event.livescore.Scoreboard.Time < +livescore.Scoreboard.Time
              ) {
                event.livescore = livescore;
              } else if (check.sport.id != 8412615417) {
                event.livescore = livescore;
              }

              return false;
            }
          });
        }
      }

      if (context.state.events_live_detail.length > 0) {
        if (context.state.events_live_detail[0].event.id == id_event) {
          if (
            +context.state.events_live_detail[0].event.livescore.Scoreboard
              .Time < +livescore.Scoreboard.Time
          ) {
            context.state.events_live_detail[0].event.livescore = livescore;
          }
        }
      }
    });
  },
  async updateLivescoreCashout(context, payload) {
    forEachLodash(payload, async change => {
      const id_event = change.id;

      if (context.rootGetters['user/getMyBetsInProgress']) {
        const clone = JSON.parse(
          JSON.stringify(context.rootGetters['user/getMyBetsInProgress'])
        );

        const check = findLodash(clone, {
          odds: [{ event_source: +id_event }]
        });

        // console.log('Clone: ' + JSON.stringify(clone));

        if (check) {
          let trovato = false;
          forEachLodash(change.odds.set, async data => {
            const check_unique_id = findLodash(check.odds, {
              unique_id: data.unique_id
            });

            // console.log('Check: ' + JSON.stringify(check_unique_id))

            if (check_unique_id) {
              trovato = true;

              check_unique_id.outcome_odd_value = data._attributes.odds;

              // console.log('val_cambiato: ' + JSON.stringify(check_unique_id.outcome_odd_value))
            }
          });

          if (trovato) {
            context.commit('user/SET_MY_BETS_IN_PROGRESS', clone, {
              root: true
            });
          }
        }
      }
    });
  },
  async settlementOddsLive(context, payload) {
    // console.log('payload prova', payload)
    console.log('SOCKET SETTLEMENT_ODDS_LIVE', payload);

    const event = payload;

    const code = event.code;

    if (context.rootGetters['user/getDetailMyBets']) {
      var clone = JSON.parse(
        JSON.stringify(context.rootGetters['user/getDetailMyBets'])
      );

      if (clone.code == code) {
        clone = event;
        context.commit('user/SET_DETAIL_MY_BETS', clone, { root: true });
      }
    }

    if (context.rootGetters['user/getMyBets']) {
      var clone = JSON.parse(
        JSON.stringify(context.rootGetters['user/getMyBets'])
      );
      var check = findLodash(clone, { code: code });

      if (check) {
        assign(check, event);
        context.commit('user/SET_MY_BETS', clone, { root: true });
      }
    }

    if (context.rootGetters['user/getMyBetsInProgress']) {
      console.log(
        'SOCKET GET_MY_BETS_IN_PROGRESS',
        context.rootGetters['user/getMyBetsInProgress']
      );
      var clone = JSON.parse(
        JSON.stringify(context.rootGetters['user/getMyBetsInProgress'])
      );
      var check = findLodash(clone, { code: code });

      if (check) {
        assign(check, event);
        context.commit('user/SET_MY_BETS_IN_PROGRESS', clone, { root: true });
      }
    }
    if (context.rootGetters['user/getMyBetsAll']) {
      var clone = JSON.parse(
        JSON.stringify(context.rootGetters['user/getMyBetsAll'])
      );
      var check = findLodash(clone, { code: code });

      if (check) {
        assign(check, event);
        context.commit('user/SET_MY_BETS_ALL', clone, { root: true });
      }
    }
    if (context.rootGetters['user/getMyBetsInProgressAll']) {
      var clone = JSON.parse(
        JSON.stringify(context.rootGetters['user/getMyBetsInProgressAll'])
      );
      var check = findLodash(clone, { code: code });

      if (check) {
        assign(check, event);
        context.commit('user/SET_MY_BETS_ALL_IN_PROGRESS', clone, {
          root: true
        });
      }
    }
  },
  async updateOddsLive(context, payload) {
    console.log('SOCKET UPDATE_ODDS_LIVE', payload);

    context.commit('IllinoisSport/updateLiveOutcomesFromFeed', payload, {
      root: true
    });
    if (context.state.preview_live.length > 0) {
      forEachLodash(payload, async change => {
        const check_exists = findLodash(context.state.preview_live, event => {
          return event.events_sources.includes(change.id);
        });

        if (check_exists) {
          const check = findLodash(check_exists.events, { id: change.id });

          if (check.odds) {
            try {
              forEachLodash(check.odds, async oddsGroup => {
                oddsGroup.has_to_update = false;
                forEachLodash(oddsGroup.odds, outcome_to_update => {
                  delete outcome_to_update.has_to_update;
                  delete outcome_to_update.outcome_odd_value_backup;
                  delete outcome_to_update.outcome_status_to_refresh;
                  delete outcome_to_update.outcome_value_to_refresh;
                  delete outcome_to_update.type_change;
                });
              });

              var check_update = false;
              forEachLodash(check.odds, async oddsGroup => {
                oddsGroup.has_to_update = false;

                forEachLodash(oddsGroup.odds, outcome_to_update => {
                  const checkOdd = findLodash(change.odds.set, {
                    unique_id: outcome_to_update.unique_id
                  });

                  if (checkOdd) {
                    const new_status = checkOdd._attributes.status == 1;
                    if (
                      +outcome_to_update.outcome_odd_value !=
                        +checkOdd._attributes.odds ||
                      new_status != outcome_to_update.active
                    ) {
                      outcome_to_update.outcome_value_to_refresh =
                        +checkOdd._attributes.odds;
                      outcome_to_update.outcome_status_to_refresh =
                        checkOdd._attributes.status == 1;
                      outcome_to_update.has_to_update = true;

                      oddsGroup.has_to_update = true;
                      check_update = true;
                    }
                  } else {
                  }
                });
              });
            } catch (e) {
              console.log(e);
            }
          } else {
            var check_update = false;
          }

          if (check_update) {
            check.odds = await rulesHandler.refreshOdds(check.odds);
          }

          // console.log(check)
        } else {
          // var update = true;
          // forEachLodash(context.state.count_live, (sport) =>{
          //     var find = findLodash(sport.events, {'id':change.id})
          //     if(find){
          //         update = false
          //         return false
          //     }
          // })
          //
          // if(update){
          //     var sport_selected = findLodash(context.state.count_live, {'selected': true})
          //     if(sport_selected){
          //         await context.dispatch('fetchLive', {sport: sport_selected.sport.id, sport_id: sport_selected.sport._id, group : false});
          //     }else{
          //         await context.dispatch('fetchLive', {group : false});
          //     }
          // }
        }
      });
    }

    if (context.state.events_live_detail.length > 0) {
      forEachLodash(payload, async change => {
        if (context.state.events_live_detail[0].event.id == change.id) {
          forEachLodash(
            context.state.events_live_detail[0].event.odds,
            async oddsGroup => {
              oddsGroup.has_to_update = false;
              forEachLodash(oddsGroup.odds, outcome_to_update => {
                delete outcome_to_update.has_to_update;
                delete outcome_to_update.outcome_odd_value_backup;
                delete outcome_to_update.outcome_status_to_refresh;
                delete outcome_to_update.outcome_value_to_refresh;
                delete outcome_to_update.type_change;
              });
            }
          );

          let check_update = false;

          forEachLodash(
            context.state.events_live_detail[0].event.odds,
            async oddsGroup => {
              oddsGroup.has_to_update = false;

              forEachLodash(oddsGroup.odds, outcome_to_update => {
                const checkOdd = findLodash(change.odds.set, {
                  unique_id: outcome_to_update.unique_id
                });

                if (checkOdd) {
                  const new_status = checkOdd._attributes.status == 1;
                  if (
                    +outcome_to_update.outcome_odd_value !=
                      +checkOdd._attributes.odds ||
                    new_status != outcome_to_update.active
                  ) {
                    outcome_to_update.outcome_value_to_refresh =
                      +checkOdd._attributes.odds;
                    outcome_to_update.outcome_status_to_refresh =
                      checkOdd._attributes.status == 1;
                    outcome_to_update.has_to_update = true;

                    oddsGroup.has_to_update = true;
                    check_update = true;
                  }
                } else {
                }
              });
            }
          );

          if (check_update) {
            context.state.events_live_detail[0].event.odds =
              await rulesHandler.refreshOdds(
                context.state.events_live_detail[0].event.odds
              );
          }
        }
      });
    }

    // var cart = context.rootState.cart.bet
    // if(cart.odds.length > 0 && context.rootState.settings.odds_variation){
    //     forEachLodash(payload, async (change) =>{
    //         var check = findLodash(cart.odds, {'event_source':change.id})
    //         if(check){
    //             var checkOdd = findLodash(change.odds.set, {'unique_id':check.unique_id})
    //             if(checkOdd){
    //                 check.outcome_value_to_refresh = +checkOdd._attributes.odds
    //                 check.outcome_status_to_refresh = (checkOdd._attributes.status == 1)
    //                 console.log(check)
    //             }
    //             await context.dispatch('cart/refreshCart',{},{root:true})
    //         }
    //     })
    // }
  },

  async fetchNextEvents(context, payload) {
    if (context.rootGetters['settings/getGameConsole'] === 'marketview') {
      //console.log('market view console selected')

      await context.dispatch('odds/fetchNextEventsV2', payload, { root: true });
    } else {
      //console.log('default console selected')

      await context.dispatch('odds/fetchNextEventsV1', payload, { root: true });
    }
  },
  async fetchNextEventsV1(context, payload) {
    // payload = payload.payload;

    const request = {
      sport_id:
        payload != undefined && payload.sport_id != undefined
          ? payload.sport_id
          : undefined,
      sport:
        payload != undefined && payload.sport != undefined
          ? payload.sport
          : undefined
    };
    return axios
      .post(
        `${context.rootGetters['settings/getUrlApi']}/events/get-next-events`,
        request,
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
          }
        }
      )
      .then(async res => {
        if (res.data.result.length > 0) {
          const count = JSON.parse(JSON.stringify(res.data.result));
          const onlyManager =
            context.rootGetters['settings/getPlatformId'] == 0;
          const rules = {
            manager: context.rootGetters['rules/getRulesManager'],
            skin: !onlyManager ? context.rootGetters['rules/getRulesSkin'] : [],
            lang: context.rootGetters['settings/getLanguage']
          };

          const producer = 0;

          const count_with_rules = filter(count, function (o) {
            return o.status_rule != false;
          });

          const events_preview_next =
            await eventsOddsHandler.refactorNextEvents(
              res.data.result,
              rules,
              producer,
              onlyManager,
              payload.group
            );

          forEachLodash(count_with_rules, count => {
            delete count.events;
          });

          //if(ev.events && _.size(ev.events)>0){
          const events_filtered = filter(events_preview_next, ev => {
            return (
              ev.sport.status == true &&
              ev.category.status == true &&
              ev.tournament.status == true &&
              ev.events[0].status == 1
            );
          });
          //}

          context.commit('SET_COUNT_NEXT_EVENTS', count_with_rules);
          context.commit('SET_PREVIEW_NEXT_EVENTS', []);
          context.commit('SET_PREVIEW_NEXT_EVENTS', events_filtered);
          // forEachLodash(events_preview_live, (tourn) =>{
          //     context.commit('ADD_PREVIEW_NEXT_EVENTS', tourn)
          // })
        }

        return;
      })
      .catch(error => {
        console.log(error);
      });
  },
  async fetchNextEventsV2(context, payload) {
    //payload = payload.payload;

    const defaultPage = 1;
    const defaultLimitEvents = 5;
    const limit = payload.limit != null ? payload.limit : defaultLimitEvents;
    const page = payload.page != null ? payload.page : defaultPage;
    const mobilePlatform =
      payload.mobilePlatform != null ? payload.mobilePlatform : false;

    const request = {
      sport_id:
        payload != undefined && payload.sport_id != undefined
          ? payload.sport_id
          : undefined,
      sport:
        payload != undefined && payload.sport != undefined
          ? payload.sport
          : undefined,
      platformId: payload.platformId,
      limit: limit,
      page: page,
      lang: context.rootGetters['settings/getLanguage'],
      mobilePlatform: mobilePlatform
    };
    return axios
      .post(
        `${context.rootGetters['settings/getUrlApi']}/events/get-next-events-v2`,
        request,
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
          }
        }
      )
      .then(async res => {
        if (res.data.result.length > 0) {
          const count = JSON.parse(JSON.stringify(res.data.result));
          const onlyManager =
            context.rootGetters['settings/getPlatformId'] == 0;
          const rules = {
            manager: context.rootGetters['rules/getRulesManager'],
            skin: !onlyManager ? context.rootGetters['rules/getRulesSkin'] : [],
            lang: context.rootGetters['settings/getLanguage']
          };

          const producer = 0;

          const count_with_rules = filter(count, function (o) {
            return o.status_rule != false;
          });

          const events_preview_next =
            await eventsOddsHandler.refactorNextEvents(
              res.data.result,
              rules,
              producer,
              onlyManager,
              payload.group
            );
          // console.log('events_preview_next')
          // console.log(events_preview_next)

          forEachLodash(count_with_rules, count => {
            delete count.events;
          });

          // for(const event of events_preview_next){
          //
          //     console.log('event')
          //     console.log(event.events[0].id)
          //
          //     if(event.sport.status == true){
          //         console.log('sport status true !')
          //     }else{
          //         console.log('sport status false !')
          //     }
          //
          //     if(event.category.status == true){
          //         console.log('category status true !')
          //     }else{
          //         console.log('category status false !')
          //     }
          //
          //     if(event.tournament.status == true){
          //         console.log('tournament status true !')
          //     }else{
          //         console.log('tournament status false !')
          //     }
          //
          //     if(event.events[0].status == 1){
          //         console.log('event status 1 !')
          //     }else{
          //         console.log('event status 0!')
          //     }
          //
          //     console.log('*************')
          //
          // }

          // //if(ev.events && _.size(ev.events)>0){
          // var events_filtered = filter(events_preview_next, (ev) => {
          //     console.log('ev: ')
          //     console.log(ev)
          //     return ev.sport.status == true && ev.category.status == true && ev.tournament.status == true && ev.events[0].status == 1
          // })
          // //}
          //
          // if(events_filtered && events_filtered.length > 5){
          //     events_filtered = events_filtered.slice(0,5);
          // }

          context.commit('SET_COUNT_NEXT_EVENTS', count_with_rules);
          context.commit('SET_PREVIEW_NEXT_EVENTS', []);
          context.commit('SET_PREVIEW_NEXT_EVENTS', events_preview_next);
          // forEachLodash(events_preview_live, (tourn) =>{
          //     context.commit('ADD_PREVIEW_NEXT_EVENTS', tourn)
          // })

          //todo check if headerSign is null or [] , look when normal platform is set, what return
          const headerSign = res.data.result[0].headerSign;

          if (headerSign != null) {
            await context.dispatch(
              'marketview/updateSpreadsListAndSpreadSelected',
              {
                type: 'nextEvents',
                headerSign: headerSign,
                sport: payload.sport,
                events: res.data.result[0].events
              },
              { root: true }
            );
          }

          if (res.data.paging != null && res.data.paging.pages) {
            await context.dispatch(
              'marketview/setAvailablePagesForNextEvents',
              res.data.paging.pages,
              { root: true }
            );
          }

          if (res.data.sportsInNext3Hours != null) {
            await context.dispatch(
              'marketview/setAvailableSportsInNext3Hours',
              res.data.sportsInNext3Hours,
              { root: true }
            );
          }
        } else {
          context.commit('SET_COUNT_NEXT_EVENTS', 0);
          context.commit('SET_PREVIEW_NEXT_EVENTS', []);
        }

        return;
      })
      .catch(error => {
        console.log(error);
        context.commit('SET_COUNT_NEXT_EVENTS', 0);
        context.commit('SET_PREVIEW_NEXT_EVENTS', []);
      });
  },
  async fetchEventsDayServer(context, payload) {
    const request = {
      sport_id:
        payload != undefined && payload.sport_id != undefined
          ? payload.sport_id
          : undefined,
      sport:
        payload != undefined && payload.sport != undefined
          ? payload.sport
          : undefined,
      language_user:
        payload != undefined && payload.language_user != undefined
          ? payload.language_user
          : undefined,
      timezone:
        payload != undefined && payload.timezone != undefined
          ? payload.timezone
          : undefined,
      skip: context.rootGetters['odds/getDaySkip'],
      limit: context.rootGetters['odds/getDayLimit'],
      forceDefaultGameConsole:
        payload.forceDefaultGameConsole != null
          ? payload.forceDefaultGameConsole
          : null,
      groupOddsWithSpreads:
        payload.groupOddsWithSpreads != null
          ? payload.groupOddsWithSpreads
          : false,
      mobilePlatform:
        payload.mobilePlatform != null ? payload.mobilePlatform : false
    };

    // let request = {
    //     sport_id: (payload != undefined && payload.sport_id != undefined) ? payload.sport_id : undefined,
    //     sport: (payload != undefined && payload.sport != undefined) ? payload.sport : undefined,
    // }

    return axios
      .post(
        //`${context.rootGetters['settings/getUrlApi']}/events/get-events-day-server`,
        `${context.rootGetters['settings/getUrlApi']}/events/get-events-day-cache`,
        request,
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
          }
        }
      )
      .then(async res => {
        if (res.data.result.length > 0) {
          const count = JSON.parse(JSON.stringify(res.data.result));

          if (size(count[0].events) == 0) {
            await context.commit('SET_PREVIEW_EVENTS_DAY', []);
            await context.commit('SET_COUNT_EVENTS_DAY', []);
            return;
          }
          const onlyManager =
            context.rootGetters['settings/getPlatformId'] == 0;
          const rules = {
            manager: context.rootGetters['rules/getRulesManager'],
            skin: !onlyManager ? context.rootGetters['rules/getRulesSkin'] : [],
            lang: context.rootGetters['settings/getLanguage']
          };

          const producer = 0;

          const count_with_rules = filter(count, function (o) {
            return o.status_rule != false;
          });

          // console.log(res.data.result)

          const events_preview_day = await eventsOddsHandler.refactorEventsDay(
            res.data.result,
            rules,
            producer,
            onlyManager,
            false,
            res.data.result[0].headerSign
          );
          //console.log(events_preview_day)
          //console.log("res.data.result",res.data.result)
          forEachLodash(count_with_rules, count => {
            delete count.events;
          });

          const events_filtered = filter(events_preview_day, ev => {
            //console.log(ev.sport.status,ev.category.status,ev.tournament.status, ev.events[0].status)
            if (ev.events[0] !== undefined) {
              return (
                ev.sport.status == true &&
                ev.category.status == true &&
                ev.tournament.status == true &&
                (ev.events[0].status == 1 || ev.events[0].status == 9)
              );
            } else {
              return;
            }
          });
          //console.log("SERVER",count_with_rules)
          //console.log("SERVER",events_filtered)
          context.commit('SET_COUNT_EVENTS_DAY', count_with_rules);
          context.commit('SET_PREVIEW_EVENTS_DAY', []);
          context.commit('SET_PREVIEW_EVENTS_DAY', events_filtered);
          // forEachLodash(events_preview_live, (tourn) =>{
          //     context.commit('ADD_PREVIEW_NEXT_EVENTS', tourn)
          // })

          //todo check if headerSign is null or [] , look when normal platform is set, what return
          const headerSign = res.data.result[0].headerSign;
          if (headerSign != null) {
            await context.dispatch(
              'marketview/updateSpreadsListAndSpreadSelected',
              {
                type: 'eventsOfDay',
                headerSign: headerSign,
                sport: payload.sport,
                events: res.data.result[0].events
              },
              { root: true }
            );
          }
          // console.log('fetchEventsDayServer:')
          // console.log('headerSign is: ')
          // console.log(headerSign)
        } else {
          await context.commit('ADD_PREVIEW_EVENTS_DAY', []);
          await context.commit('SET_COUNT_EVENTS_DAY', []);
          return;
        }

        return;
      })
      .catch(error => {
        console.log(error);
      });
  },
  async fetchEventsDay(context, payload) {
    const request = {
      sport_id:
        payload != undefined && payload.sport_id != undefined
          ? payload.sport_id
          : undefined,
      sport:
        payload != undefined && payload.sport != undefined
          ? payload.sport
          : undefined,
      language_user:
        payload != undefined && payload.language_user != undefined
          ? payload.language_user
          : undefined,
      timezone:
        payload != undefined && payload.timezone != undefined
          ? payload.timezone
          : undefined,
      skip: 0,
      limit: 15
    };

    // let request = {
    //     sport_id: (payload != undefined && payload.sport_id != undefined) ? payload.sport_id : undefined,
    //     sport: (payload != undefined && payload.sport != undefined) ? payload.sport : undefined,
    // }

    return axios
      .post(
        `${context.rootGetters['settings/getUrlApi']}/events/get-events-day`,
        request,
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
          }
        }
      )
      .then(async res => {
        if (res.data.result.length > 0) {
          const count = JSON.parse(JSON.stringify(res.data.result));
          const onlyManager =
            context.rootGetters['settings/getPlatformId'] == 0;
          const rules = {
            manager: context.rootGetters['rules/getRulesManager'],
            skin: !onlyManager ? context.rootGetters['rules/getRulesSkin'] : [],
            lang: context.rootGetters['settings/getLanguage']
          };

          const producer = 0;

          const count_with_rules = filter(count, function (o) {
            return o.status_rule != false;
          });

          const events_preview_day = await eventsOddsHandler.refactorEventsDay(
            res.data.result,
            rules,
            producer,
            onlyManager,
            false
          );
          //console.log("res.data.result normal",res.data.result)
          forEachLodash(count_with_rules, count => {
            delete count.events;
          });

          const events_filtered = filter(events_preview_day, ev => {
            return (
              ev.sport.status == true &&
              ev.category.status == true &&
              ev.tournament.status == true &&
              ev.events[0].status == 1
            );
          });
          //console.log("DAY",count_with_rules)
          //console.log("DAY",events_filtered)
          context.commit('SET_COUNT_EVENTS_DAY', count_with_rules);
          context.commit('SET_PREVIEW_EVENTS_DAY', []);
          context.commit('SET_PREVIEW_EVENTS_DAY', events_filtered);
          // forEachLodash(events_preview_live, (tourn) =>{
          //     context.commit('ADD_PREVIEW_NEXT_EVENTS', tourn)
          // })
        }

        return;
      })
      .catch(error => {
        console.log(error);
      });
  },
  async fetchEventsDayMoreServer(context, payload) {
    const request = {
      sport:
        payload != undefined && payload.sport != undefined
          ? payload.sport
          : undefined,
      language_user:
        payload != undefined && payload.language_user != undefined
          ? payload.language_user
          : undefined,
      timezone:
        payload != undefined && payload.timezone != undefined
          ? payload.timezone
          : undefined,
      skip:
        payload != undefined && payload.skip != undefined
          ? payload.skip
          : undefined,
      limit:
        payload != undefined && payload.limit != undefined
          ? payload.limit
          : undefined,
      forceDefaultGameConsole:
        payload.forceDefaultGameConsole != null
          ? payload.forceDefaultGameConsole
          : null,
      groupOddsWithSpreads:
        payload.groupOddsWithSpreads != null
          ? payload.groupOddsWithSpreads
          : false,
      mobilePlatform:
        payload.mobilePlatform != null ? payload.mobilePlatform : false
    };

    // let request = {
    //     sport_id: (payload != undefined && payload.sport_id != undefined) ? payload.sport_id : undefined,
    //     sport: (payload != undefined && payload.sport != undefined) ? payload.sport : undefined,
    // }

    return axios
      .post(
        //`${context.rootGetters['settings/getUrlApi']}/events/get-events-day-server`,
        `${context.rootGetters['settings/getUrlApi']}/events/get-events-day-cache`,
        request,
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
          }
        }
      )
      .then(async res => {
        if (res.data.result.length > 0) {
          const count = JSON.parse(JSON.stringify(res.data.result));

          const onlyManager =
            context.rootGetters['settings/getPlatformId'] == 0;
          const rules = {
            manager: context.rootGetters['rules/getRulesManager'],
            skin: !onlyManager ? context.rootGetters['rules/getRulesSkin'] : [],
            lang: context.rootGetters['settings/getLanguage']
          };

          const producer = 0;

          const count_with_rules = filter(count, function (o) {
            return o.status_rule != false;
          });

          const events_preview_day = await eventsOddsHandler.refactorEventsDay(
            res.data.result,
            rules,
            producer,
            onlyManager,
            false,
            res.data.result[0].headerSign
          );

          forEachLodash(count_with_rules, count => {
            delete count.events;
          });

          const events_filtered = filter(events_preview_day, ev => {
            return (
              ev.sport.status == true &&
              ev.category.status == true &&
              ev.tournament.status == true &&
              ev.events[0].status == 1
            );
          });

          //todo check if headerSign is null or [] , look when normal platform is set, what return
          const headerSign = res.data.result[0].headerSign;

          // console.log('fetchEventsDayMoreServer:')
          // console.log('headerSign is: ')
          // console.log(headerSign)

          if (headerSign != null) {
            await context.dispatch(
              'marketview/updateSpreadsListAndSpreadSelected',
              {
                type: 'eventsOfDayMore',
                headerSign: headerSign,
                sport: payload.sport,
                events: res.data.result[0].events
              },
              { root: true }
            );
          }

          await context.commit('ADD_PREVIEW_EVENTS_DAY', events_filtered);
          await context.commit('SET_COUNT_EVENTS_DAY', count_with_rules);
          //forEachLodash(events_filtered,async(event)=>{
          /*for await (let event of events_filtered){

                        await context.commit('ADD_PREVIEW_EVENTS_DAY', event)
                    }*/
          return;
          // forEachLodash(events_preview_live, (tourn) =>{
          //     context.commit('ADD_PREVIEW_NEXT_EVENTS', tourn)
          // })
        } else {
          return;
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  async fetchEventsDayMore(context, payload) {
    const request = {
      sport:
        payload != undefined && payload.sport != undefined
          ? payload.sport
          : undefined,
      language_user:
        payload != undefined && payload.language_user != undefined
          ? payload.language_user
          : undefined,
      timezone:
        payload != undefined && payload.timezone != undefined
          ? payload.timezone
          : undefined,
      skip:
        payload != undefined && payload.skip != undefined
          ? payload.skip
          : undefined,
      limit:
        payload != undefined && payload.limit != undefined
          ? payload.limit
          : undefined,
      total:
        payload != undefined && payload.total != undefined
          ? payload.total
          : undefined,
      count:
        payload != undefined && payload.count != undefined
          ? payload.count
          : undefined,
      lastitem:
        payload != undefined && payload.lastitem != undefined
          ? payload.lastitem
          : undefined
    };

    // let request = {
    //     sport_id: (payload != undefined && payload.sport_id != undefined) ? payload.sport_id : undefined,
    //     sport: (payload != undefined && payload.sport != undefined) ? payload.sport : undefined,
    // }

    return axios
      .post(
        `${context.rootGetters['settings/getUrlApi']}/events/get-events-day-next`,
        request,
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
          }
        }
      )
      .then(async res => {
        if (res.data.result.length > 0) {
          const count = JSON.parse(JSON.stringify(res.data.result));
          const onlyManager =
            context.rootGetters['settings/getPlatformId'] == 0;
          const rules = {
            manager: context.rootGetters['rules/getRulesManager'],
            skin: !onlyManager ? context.rootGetters['rules/getRulesSkin'] : [],
            lang: context.rootGetters['settings/getLanguage']
          };

          const producer = 0;

          const count_with_rules = filter(count, function (o) {
            return o.status_rule != false;
          });

          const events_preview_day = await eventsOddsHandler.refactorEventsDay(
            res.data.result,
            rules,
            producer,
            onlyManager,
            false
          );

          forEachLodash(count_with_rules, count => {
            delete count.events;
          });

          const events_filtered = filter(events_preview_day, ev => {
            return (
              ev.sport.status == true &&
              ev.category.status == true &&
              ev.tournament.status == true &&
              ev.events[0].status == 1
            );
          });

          await context.commit('ADD_PREVIEW_EVENTS_DAY', events_filtered);
          //forEachLodash(events_filtered,async(event)=>{
          /*for await (let event of events_filtered){

                        await context.commit('ADD_PREVIEW_EVENTS_DAY', event)
                    }*/
          return;
          // forEachLodash(events_preview_live, (tourn) =>{
          //     context.commit('ADD_PREVIEW_NEXT_EVENTS', tourn)
          // })
        } else {
          return;
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  async oddChangeFromSocketPreview(context, payload) {
    if (context.state.preview.length > 0 && !isEmpty(payload)) {
      // console.log(payload)

      const source_to_find = payload._attributes.event_id;
      const previewCollection = await findLodash(state.preview, element => {
        return element.events_sources.includes(source_to_find);
      });

      if (!isEmpty(previewCollection)) {
        const event = await findLodash(previewCollection.events, {
          source: source_to_find
        });

        await Promise.all(
          Object.keys(event.odds).map(async index => {
            const odd = event.odds[index];

            if (!odd.freeze) {
              const payload_market = await findLodash(
                payload.odds.market,
                function (market) {
                  if (market != null) {
                    const id_market = market._attributes.id;
                    let market_unique_id = market._attributes.unique_id;
                    if (
                      market_unique_id == undefined ||
                      market_unique_id == ''
                    ) {
                      market_unique_id =
                        market._attributes.specifiers != undefined &&
                        market._attributes.specifiers != ''
                          ? id_market + '#' + market._attributes.specifiers
                          : id_market;
                    }

                    if (market_unique_id == odd.unique_id) {
                      return market;
                    }
                  }
                }
              );

              if (payload_market != undefined) {
                //ToDo update Outcome from unique id
                odd.status_to_refresh =
                  payload_market._attributes.status == '1';

                for (const outcome_to_update of odd.odds) {
                  const outcome = await findLodash(
                    payload_market.outcome,
                    function (out) {
                      if (out._attributes.id == outcome_to_update.id_outcome) {
                        return out;
                      }
                    }
                  );

                  if (outcome != undefined) {
                    outcome_to_update.outcome_value_to_refresh =
                      outcome._attributes.odds;
                    outcome_to_update.outcome_status_to_refresh =
                      outcome._attributes.active == '1';
                  }
                }
              }
            }
          })
        );

        event.odds = await rulesHandler.refreshOdds(event.odds);
      }
    }
  },
  async oddChangeFromSocketDetail(context, payload) {
    if (context.state.events_detail_active.length > 0 && !isEmpty(payload)) {
      const source_to_find = payload._attributes.event_id;
      const event_detail = await findLodash(state.events_detail, element => {
        return element.source == source_to_find;
      });

      if (!isEmpty(event_detail)) {
        const event = event_detail.event;

        await Promise.all(
          Object.keys(event.odds).map(async index => {
            const odd = event.odds[index];

            if (!odd.freeze) {
              const payload_market = await findLodash(
                payload.odds.market,
                function (market) {
                  if (market != null) {
                    const id_market = market._attributes.id;
                    let market_unique_id = market._attributes.unique_id;
                    if (
                      market_unique_id == undefined ||
                      market_unique_id == ''
                    ) {
                      market_unique_id =
                        market._attributes.specifiers != undefined &&
                        market._attributes.specifiers != ''
                          ? id_market + '#' + market._attributes.specifiers
                          : id_market;
                    }

                    if (market != null && market_unique_id == odd.unique_id) {
                      return market;
                    }
                  }
                }
              );

              if (payload_market != undefined) {
                odd.status_to_refresh =
                  payload_market._attributes.status == '1';

                for (const outcome_to_update of odd.odds) {
                  const outcome = await findLodash(
                    payload_market.outcome,
                    function (out) {
                      if (out._attributes.id == outcome_to_update.id_outcome) {
                        return out;
                      }
                    }
                  );

                  if (outcome != undefined) {
                    outcome_to_update.outcome_value_to_refresh =
                      outcome._attributes.odds;
                    outcome_to_update.outcome_status_to_refresh =
                      outcome._attributes.active == '1';
                  }
                }
              }
            }
          })
        );

        event.odds = await rulesHandler.refreshOdds(event.odds);
      }
    }
  },
  async fetchEventDetail(context, payload) {
    if (context.rootGetters['settings/getGameConsole'] === 'marketview') {
      await context.dispatch('odds/fetchEventDetailV2', payload, {
        root: true
      });
    } else {
      await context.dispatch('odds/fetchEventDetailV1', payload, {
        root: true
      });
    }
  },

  async fetchEventDetailV1(context, payload) {
    // payload = payload.payload;

    if (!state.events_detail_active.includes(payload.source)) {
      context.commit('ADD_EVENTS_DETAIL_ACTIVE', payload.source);

      await axios
        .post(
          `${context.rootGetters['settings/getUrlApi']}/events/getodds/tournament/event`,
          {
            event: payload.source,
            platform: context.rootGetters['settings/getPlatformId'],
            type: 'groupOdds',
            section: 'sport',
            typegroup: 'detail',
            sport: payload.sport ? payload.sport : '',
            tournament: payload.tournament ? payload.tournament : '',
            group: payload.group,
            lang: context.rootGetters['settings/getLanguage'],
            // "product_id": (payload.status == 2) ? 1 : 0
            product_id: 0
          },
          {
            headers: {
              Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
            }
          }
        )
        .then(async res => {
          //console.log("E",res.data.events)
          if (res.data.events) {
            if (res.data.events.odds && res.data.events.odds.length > 0) {
              //res.data.events = JSON.parse(JSON.stringify(res.data.events))
              for await (const val of res.data.events.odds) {
                //res.data.events.odds.forEach((val)=>{

                if (val.markets && val.markets.length > 0) {
                  for await (const outcome of val.markets) {
                    //val.markets.forEach((outcome)=>{

                    let valueSpec = _.toString(outcome.specifiers_parsed);
                    if (!valueSpec.startsWith('-')) {
                      valueSpec = `+${valueSpec}`;
                    }
                    //console.log(outcome.name,valueSpec)

                    const sorted = _.find(outcome.outcome, { name: valueSpec });
                    if (sorted) {
                      //console.log("TROVATO",sorted,outcome.specifiers_parsed)
                      if (sorted.sort) {
                        _.assign(outcome, { sorted: sorted.sort });
                      }
                    }
                    _.assign(outcome, { spec: outcome.specifiers_parsed });
                    //outcome.spec = outcome.specifiers_parsed
                  }
                }
              }
            }
            const onlyManager =
              context.rootGetters['settings/getPlatformId'] == 0;
            const rules = {
              manager: context.rootGetters['rules/getRulesManager'],
              skin: !onlyManager
                ? context.rootGetters['rules/getRulesSkin']
                : [],
              lang: context.rootGetters['settings/getLanguage']
            };

            const producer = '0';
            const data_event = await eventsOddsHandler.refactorDetail(
              res.data,
              rules,
              producer,
              onlyManager,
              payload.source
            );
            // console.log('eee: ', data_event);

            /**
             * Rimozione ordinamento
             */
            // let reindex = []
            // if(_.size(data_event.event.odds)>0){
            //
            //     let markets = _.groupBy(data_event.event.odds,"id_market");
            //     for (const [key, value] of Object.entries(markets)) {
            //
            //         let valOrd = value;
            //         valOrd =_.orderBy(valOrd, ['sorted','spec'], ['asc','asc']);
            //         reindex.push(...valOrd)
            //         //   console.log("2",value)
            //     }
            //
            // }
            // if(reindex.length>0){
            //     data_event.event.odds=reindex
            // }
            /**
             * Fine rimozione ordinamento
             */
            context.commit('ADD_EVENT_DETAIL', data_event);
          } else {
            // Todo no events
            const data_events = {
              tournament: {
                ...res.data.tournament[0]
              },
              message: {
                num_events: 0
              }
            };

            context.commit('ADD_EVENT_DETAIL', data_events);
          }
        });
    }

    if (
      payload.featuredTournament == null ||
      payload.featuredTournament === false
    ) {
      await context.dispatch('settings/setStatusBannerCentral', false, {
        root: true
      });
    }
  },
  async fetchEventDetailV2(context, payload) {
    // console.log('fetchEventDetailV2')
    //
    // console.log('payload')
    // console.log(payload)

    if (!state.events_detail_active.includes(payload.source)) {
      //context.commit('ADD_EVENTS_DETAIL_ACTIVE', payload.source)
      context.commit('SET_EVENTS_DETAIL_ACTIVE', null);
      context.commit('SET_EVENTS_DETAIL_ACTIVE', [payload.source]);

      window.parent.postMessage(
        {
          type: 'eventOpened',
          eventId: payload.source,
          sportId: payload.sport,
          tournamentId: payload.tournament,
          eventName: payload.competitorHome + ' ' + payload.competitorAway,
          eventNameBack: payload.eventName != null ? payload.eventName : null
        },
        '*'
      );

      await axios
        .post(
          `${context.rootGetters['settings/getUrlApi']}/events/getodds/tournament/event-v2`,
          {
            event: payload.source,
            platform: context.rootGetters['settings/getPlatformId'],
            type: 'groupOdds',
            section: 'sport',
            typegroup: 'detail',
            sport: payload.sport ? payload.sport : '',
            tournament: payload.tournament ? payload.tournament : '',
            group: payload.group,
            lang: context.rootGetters['settings/getLanguage'],
            // "product_id": (payload.status == 2) ? 1 : 0
            product_id: 0
          },
          {
            headers: {
              Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
            }
          }
        )
        .then(async res => {
          //console.log("E",res.data.events)

          // history.pushState(
          //     {},
          //     null,
          //     '/event-detail/' + payload.source
          // )

          const eventDetailInfo = {
            // todo evaluate to remove in future
            event: payload.source,
            platform: context.rootGetters['settings/getPlatformId'],
            sport: payload.sport ? payload.sport : '',
            tournament: payload.tournament ? payload.tournament : '',
            group: payload.group,
            lang: context.rootGetters['settings/getLanguage']
          };
          localStorage.setItem('event-detail', JSON.stringify(eventDetailInfo));

          const eventDetailExpiryTime = {
            expiryTime:
              payload.startEventTime != null
                ? payload.startEventTime
                : new Date(res.data.events.scheduled).getTime()
          };

          localStorage.setItem(
            'event-detail-expiry-time',
            JSON.stringify(eventDetailExpiryTime)
          );

          if (res.data.marketsGroups) {
            context.commit(
              'SET_MARKETS_GROUPS_DETAIL_PREMATCH',
              res.data.marketsGroups
            );
          }

          if (res.data.events) {
            const marketIdOrderMap = new Map();
            const marketIdOrderMobileMap = new Map();

            if (res.data.events.odds && res.data.events.odds.length > 0) {
              //res.data.events = JSON.parse(JSON.stringify(res.data.events))
              for await (const val of res.data.events.odds) {
                //res.data.events.odds.forEach((val)=>{

                if (val.markets && val.markets.length > 0) {
                  for await (const outcome of val.markets) {
                    //val.markets.forEach((outcome)=>{

                    let valueSpec = _.toString(outcome.specifiers_parsed);
                    if (!valueSpec.startsWith('-')) {
                      valueSpec = `+${valueSpec}`;
                    }
                    //console.log(outcome.name,valueSpec)

                    const sorted = _.find(outcome.outcome, { name: valueSpec });
                    if (sorted) {
                      //console.log("TROVATO",sorted,outcome.specifiers_parsed)
                      if (sorted.sort) {
                        _.assign(outcome, { sorted: sorted.sort });
                      }
                    }
                    _.assign(outcome, { spec: outcome.specifiers_parsed });
                    //outcome.spec = outcome.specifiers_parsed

                    marketIdOrderMap.set(
                      outcome._attributes.id,
                      outcome.orderInMainSection
                    );
                    marketIdOrderMobileMap.set(
                      outcome._attributes.id,
                      outcome.orderMobileInMainSection
                    );
                  }
                }
              }
            }
            const onlyManager =
              context.rootGetters['settings/getPlatformId'] == 0;
            const rules = {
              manager: context.rootGetters['rules/getRulesManager'],
              skin: !onlyManager
                ? context.rootGetters['rules/getRulesSkin']
                : [],
              lang: context.rootGetters['settings/getLanguage']
            };

            const producer = '0';

            const data_event = await eventsOddsHandler.refactorDetail(
              res.data,
              rules,
              producer,
              onlyManager,
              payload.source
            );

            const marketOrder = [];
            const marketMobileOrder = [];

            for (const key of marketIdOrderMap.keys()) {
              const obj = {
                marketId: key,
                sort: marketIdOrderMap.get(key)
              };
              marketOrder.push(obj);
            }

            for (const key of marketIdOrderMobileMap.keys()) {
              const obj = {
                marketId: key,
                sort: marketIdOrderMobileMap.get(key)
              };
              marketMobileOrder.push(obj);
            }

            await context.dispatch(
              'marketview/setMarketOrderForEventDetail',
              marketOrder,
              { root: true }
            );
            await context.dispatch(
              'marketview/setMobileMarketOrderForEventDetail',
              marketMobileOrder,
              { root: true }
            );
            // console.log('eee: ', data_event);

            /**
             * Rimozione ordinamento
             */
            // let reindex = []
            // if(_.size(data_event.event.odds)>0){
            //
            //     let markets = _.groupBy(data_event.event.odds,"id_market");
            //     for (const [key, value] of Object.entries(markets)) {
            //
            //         let valOrd = value;
            //         valOrd =_.orderBy(valOrd, ['sorted','spec'], ['asc','asc']);
            //         reindex.push(...valOrd)
            //         //   console.log("2",value)
            //     }
            //
            // }
            // if(reindex.length>0){
            //     data_event.event.odds=reindex
            // }
            /**
             * Fine rimozione ordinamento
             */

            //context.commit('ADD_EVENT_DETAIL', data_event);
            // console.log('caricando i nuovi event detail')
            context.commit('SET_EVENT_DETAIL', null);
            context.commit('SET_EVENT_DETAIL', [data_event]);
            await context.dispatch(
              'marketview/updateMarketsMapSizeButtonsDetailPrematch',
              res.data.mapSizeButtons,
              { root: true }
            );

            if (res.data.combinableMarkets != null) {
              context.commit(
                'cart/ADD_COMBINABLE_MARKETS',
                res.data.combinableMarkets,
                { root: true }
              );
            }
          } else {
            // Todo no events
            const data_events = {
              tournament: {
                ...res.data.tournament[0]
              },
              message: {
                num_events: 0
              }
            };
            //context.commit('ADD_EVENT_DETAIL', data_events)
            context.commit('SET_EVENT_DETAIL', null);
            context.commit('SET_EVENT_DETAIL', [data_events]);
            await context.dispatch(
              'marketview/updateMarketsMapSizeButtonsDetailPrematch',
              res.data.mapSizeButtons,
              { root: true }
            );
          }
        });
    }

    if (
      payload.featuredTournament == null ||
      payload.featuredTournament === false
    ) {
      await context.dispatch('settings/setStatusBannerCentral', false, {
        root: true
      });
    }
  },
  async fetchEventResultAndTimeDetail(context, payload) {
    if (!state.events_detail_active.includes(payload.source)) {
      const payloadObj = {
        source: payload.source
      };
      if (payload.outcomeExternalId) {
        payloadObj.outcomeExternalId = payload.outcomeExternalId;
      }
      return await axios
        .post(
          `${context.rootGetters['settings/getUrlApi']}/events/getlive/event`,
          payloadObj,
          {
            headers: {
              Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
            }
          }
        )
        .then(res => {
          if (res && res.data && res.data.events) {
            if (!payload.outcomeExternalId) {
              return res.data.events;
            }
            return {
              events: res.data.events,
              outcomeInfo: res.data.outcomeInfo || null
            };
          }
          return null;
        });
    }
  },
  async fetchEventLiveDetail(context, payload) {
    const platformId = +context.rootGetters['settings/getPlatformId'];

    if (
      context.rootGetters['settings/getGameConsole'] === 'marketview' &&
      (platformId === 54 || platformId === 99)
    ) {
      // todo remove me is only a test
      await context.dispatch('odds/fetchEventLiveDetailV4', payload, {
        root: true
      });
    } else if (
      context.rootGetters['settings/getGameConsole'] === 'marketview'
    ) {
      await context.dispatch('odds/fetchEventLiveDetailV3', payload, {
        root: true
      }); // api for take market settings from settings collection
    } else {
      await context.dispatch('odds/fetchEventLiveDetailV1', payload, {
        root: true
      });
    }
  },

  async fetchEventLiveDetailV1(context, payload) {
    if (!state.events_detail_active.includes(payload.source)) {
      context.commit('SET_EVENTS_LIVE_DETAIL_ACTIVE', []);
      context.commit('ADD_EVENTS_LIVE_DETAIL_ACTIVE', payload.source);

      await axios
        .post(
          `${context.rootGetters['settings/getUrlApi']}/events/getodds/tournament/event`,
          {
            event: payload.source,
            platform: context.rootGetters['settings/getPlatformId'],
            type: 'groupOdds',
            section: 'sport',
            typegroup: 'detail',
            sport: payload.sport ? payload.sport : '',
            tournament: payload.tournament ? payload.tournament : '',
            group: payload.group,
            lang: context.rootGetters['settings/getLanguage'],
            // "product_id": (payload.status == 2) ? 1 : 0
            product_id: 1
          },
          {
            headers: {
              Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
            }
          }
        )
        .then(async res => {
          if (res.data.events) {
            if (res.data.events.odds && res.data.events.odds.length > 0) {
              //res.data.events = JSON.parse(JSON.stringify(res.data.events))
              for await (const val of res.data.events.odds) {
                //res.data.events.odds.forEach((val)=>{

                if (val.markets && val.markets.length > 0) {
                  for await (const outcome of val.markets) {
                    //val.markets.forEach((outcome)=>{

                    let valueSpec = _.toString(outcome.specifiers_parsed);
                    if (!valueSpec.startsWith('-')) {
                      valueSpec = `+${valueSpec}`;
                    }
                    //console.log(outcome.name,valueSpec)

                    const sorted = _.find(outcome.outcome, { name: valueSpec });
                    if (sorted) {
                      //console.log("TROVATO",sorted,outcome.specifiers_parsed)
                      if (sorted.sort) {
                        _.assign(outcome, { sorted: sorted.sort });
                      }
                    }
                    _.assign(outcome, { spec: outcome.specifiers_parsed });
                    //outcome.spec = outcome.specifiers_parsed
                  }
                }
              }
            }
            const onlyManager =
              context.rootGetters['settings/getPlatformId'] == 0;
            const rules = {
              manager: context.rootGetters['rules/getRulesManager'],
              skin: !onlyManager
                ? context.rootGetters['rules/getRulesSkin']
                : [],
              lang: context.rootGetters['settings/getLanguage']
            };

            const producer = 1;
            const data_event = await eventsOddsHandler.refactorDetail(
              res.data,
              rules,
              producer,
              onlyManager,
              payload.source
            );

            /**
             * Rimozione ordinamento market enzo
             */
            // let reindex = []
            // if(_.size(data_event.event.odds)>0){
            //
            //     let markets = _.groupBy(data_event.event.odds,"id_market");
            //     for (const [key, value] of Object.entries(markets)) {
            //
            //         let valOrd = value;
            //         valOrd =_.orderBy(valOrd, ['sorted','spec'], ['asc','asc']);
            //         reindex.push(...valOrd)
            //         //   console.log("2",value)
            //     }
            //
            // }
            // if(reindex.length>0){
            //     data_event.event.odds=reindex
            // }
            /**
             * Fine Rimozione ordinamento market enzo
             */
            // console.log(data_event)
            context.commit('SET_EVENT_LIVE_DETAIL', []);
            context.commit('ADD_EVENT_LIVE_DETAIL', data_event);
          } else {
            // Todo no events
            const data_events = {
              tournament: {
                ...res.data.tournament[0]
              },
              message: {
                num_events: 0
              }
            };

            context.commit('ADD_EVENT_LIVE_DETAIL', data_events);
          }
        });
    }
  },

  async fetchEventLiveDetailV2(context, payload) {
    if (!state.events_detail_active.includes(payload.source)) {
      context.commit('SET_EVENTS_LIVE_DETAIL_ACTIVE', []);
      context.commit('ADD_EVENTS_LIVE_DETAIL_ACTIVE', payload.source);

      await axios
        .post(
          `${context.rootGetters['settings/getUrlApi']}/events/getodds/tournament/event-live-v2`,
          {
            event: payload.source,
            platform: context.rootGetters['settings/getPlatformId'],
            type: 'groupOdds',
            section: 'sport',
            typegroup: 'detail',
            sport: payload.sport ? payload.sport : '',
            tournament: payload.tournament ? payload.tournament : '',
            group: payload.group,
            lang: context.rootGetters['settings/getLanguage'],
            // "product_id": (payload.status == 2) ? 1 : 0
            product_id: 1
          },
          {
            headers: {
              Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
            }
          }
        )
        .then(async res => {
          if (res.data.marketsGroups) {
            context.commit(
              'SET_MARKETS_GROUPS_DETAIL_LIVE',
              res.data.marketsGroups
            );
          }

          if (res.data.events) {
            const marketIdOrderMap = new Map();
            const marketIdOrderMobileMap = new Map();

            if (res.data.events.odds && res.data.events.odds.length > 0) {
              //res.data.events = JSON.parse(JSON.stringify(res.data.events))
              for await (const val of res.data.events.odds) {
                //res.data.events.odds.forEach((val)=>{

                if (val.markets && val.markets.length > 0) {
                  for await (const outcome of val.markets) {
                    //val.markets.forEach((outcome)=>{

                    let valueSpec = _.toString(outcome.specifiers_parsed);
                    if (!valueSpec.startsWith('-')) {
                      valueSpec = `+${valueSpec}`;
                    }
                    //console.log(outcome.name,valueSpec)

                    const sorted = _.find(outcome.outcome, { name: valueSpec });
                    if (sorted) {
                      //console.log("TROVATO",sorted,outcome.specifiers_parsed)
                      if (sorted.sort) {
                        _.assign(outcome, { sorted: sorted.sort });
                      }
                    }
                    _.assign(outcome, { spec: outcome.specifiers_parsed });
                    //outcome.spec = outcome.specifiers_parsed

                    marketIdOrderMap.set(
                      outcome._attributes.id,
                      outcome.orderInMainSection
                    );
                    marketIdOrderMobileMap.set(
                      outcome._attributes.id,
                      outcome.orderMobileInMainSection
                    );
                  }
                }
              }
            }
            const onlyManager =
              context.rootGetters['settings/getPlatformId'] == 0;
            const rules = {
              manager: context.rootGetters['rules/getRulesManager'],
              skin: !onlyManager
                ? context.rootGetters['rules/getRulesSkin']
                : [],
              lang: context.rootGetters['settings/getLanguage']
            };

            const producer = 1;
            const data_event = await eventsOddsHandler.refactorDetail(
              res.data,
              rules,
              producer,
              onlyManager,
              payload.source
            );

            const marketOrder = [];
            const marketMobileOrder = [];

            for (const key of marketIdOrderMap.keys()) {
              const obj = {
                marketId: key,
                sort: marketIdOrderMap.get(key)
              };
              marketOrder.push(obj);
            }

            for (const key of marketIdOrderMobileMap.keys()) {
              const obj = {
                marketId: key,
                sort: marketIdOrderMobileMap.get(key)
              };
              marketMobileOrder.push(obj);
            }

            await context.dispatch(
              'marketview/setMarketOrderForEventDetailLive',
              marketOrder,
              { root: true }
            );
            await context.dispatch(
              'marketview/setMobileMarketOrderForEventDetailLive',
              marketMobileOrder,
              { root: true }
            );

            /**
             * Rimozione ordinamento market enzo
             */
            // let reindex = []
            // if(_.size(data_event.event.odds)>0){
            //
            //     let markets = _.groupBy(data_event.event.odds,"id_market");
            //     for (const [key, value] of Object.entries(markets)) {
            //
            //         let valOrd = value;
            //         valOrd =_.orderBy(valOrd, ['sorted','spec'], ['asc','asc']);
            //         reindex.push(...valOrd)
            //         //   console.log("2",value)
            //     }
            //
            // }
            // if(reindex.length>0){
            //     data_event.event.odds=reindex
            // }
            /**
             * Fine Rimozione ordinamento market enzo
             */
            // console.log(data_event)
            context.commit('SET_EVENT_LIVE_DETAIL', []);
            context.commit('ADD_EVENT_LIVE_DETAIL', data_event);
            await context.dispatch(
              'marketview/updateMarketsMapSizeButtonsDetailLive',
              res.data.mapSizeButtons,
              { root: true }
            );
          } else {
            // Todo no events
            const data_events = {
              tournament: {
                ...res.data.tournament[0]
              },
              message: {
                num_events: 0
              }
            };

            context.commit('ADD_EVENT_LIVE_DETAIL', data_events);
          }
        });
    }
  },

  async fetchEventLiveDetailV3(context, payload) {
    if (!state.events_detail_active.includes(payload.source)) {
      context.commit('SET_EVENTS_LIVE_DETAIL_ACTIVE', []);
      context.commit('ADD_EVENTS_LIVE_DETAIL_ACTIVE', payload.source);

      await axios
        .post(
          `${context.rootGetters['settings/getUrlApi']}/events/getodds/tournament/event`,
          {
            event: payload.source,
            platform: context.rootGetters['settings/getPlatformId'],
            type: 'groupOdds',
            section: 'sport',
            typegroup: 'detail',
            sport: payload.sport ? payload.sport : '',
            tournament: payload.tournament ? payload.tournament : '',
            group: payload.group,
            lang: context.rootGetters['settings/getLanguage'],
            // "product_id": (payload.status == 2) ? 1 : 0
            product_id: 1
          },
          {
            headers: {
              Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
            }
          }
        )
        .then(async res => {
          if (res.data.events) {
            if (res.data.events.odds && res.data.events.odds.length > 0) {
              //res.data.events = JSON.parse(JSON.stringify(res.data.events))
              for await (const val of res.data.events.odds) {
                //res.data.events.odds.forEach((val)=>{

                if (val.markets && val.markets.length > 0) {
                  for await (const outcome of val.markets) {
                    //val.markets.forEach((outcome)=>{

                    let valueSpec = _.toString(outcome.specifiers_parsed);
                    if (!valueSpec.startsWith('-')) {
                      valueSpec = `+${valueSpec}`;
                    }
                    //console.log(outcome.name,valueSpec)

                    const sorted = _.find(outcome.outcome, { name: valueSpec });
                    if (sorted) {
                      //console.log("TROVATO",sorted,outcome.specifiers_parsed)
                      if (sorted.sort) {
                        _.assign(outcome, { sorted: sorted.sort });
                      }
                    }
                    _.assign(outcome, { spec: outcome.specifiers_parsed });
                    //outcome.spec = outcome.specifiers_parsed
                  }
                }
              }
            }
            const onlyManager =
              context.rootGetters['settings/getPlatformId'] == 0;
            const rules = {
              manager: context.rootGetters['rules/getRulesManager'],
              skin: !onlyManager
                ? context.rootGetters['rules/getRulesSkin']
                : [],
              lang: context.rootGetters['settings/getLanguage']
            };

            const producer = 1;
            const data_event = await eventsOddsHandler.refactorDetail(
              res.data,
              rules,
              producer,
              onlyManager,
              payload.source
            );

            /**
             * Rimozione ordinamento market enzo
             */
            // let reindex = []
            // if(_.size(data_event.event.odds)>0){
            //
            //     let markets = _.groupBy(data_event.event.odds,"id_market");
            //     for (const [key, value] of Object.entries(markets)) {
            //
            //         let valOrd = value;
            //         valOrd =_.orderBy(valOrd, ['sorted','spec'], ['asc','asc']);
            //         reindex.push(...valOrd)
            //         //   console.log("2",value)
            //     }
            //
            // }
            // if(reindex.length>0){
            //     data_event.event.odds=reindex
            // }
            /**
             * Fine Rimozione ordinamento market enzo
             */
            // console.log(data_event)
            context.commit('SET_EVENT_LIVE_DETAIL', []);
            context.commit('ADD_EVENT_LIVE_DETAIL', data_event);

            if (res.data.mapSizeButtons != null) {
              await context.dispatch(
                'marketview/updateMarketsMapSizeButtonsDetailLive',
                res.data.mapSizeButtons,
                { root: true }
              );
            }
          } else {
            // Todo no events
            const data_events = {
              tournament: {
                ...res.data.tournament[0]
              },
              message: {
                num_events: 0
              }
            };

            context.commit('ADD_EVENT_LIVE_DETAIL', data_events);
          }
        });
    }
  },

  async fetchEventLiveDetailV4(context, payload) {
    if (!state.events_detail_active.includes(payload.source)) {
      context.commit('SET_EVENTS_LIVE_DETAIL_ACTIVE', []);
      context.commit('ADD_EVENTS_LIVE_DETAIL_ACTIVE', payload.source);

      await axios
        .post(
          `${context.rootGetters['settings/getUrlApi']}/events/getodds/tournament/event-live-v4`,
          {
            event: payload.source,
            platform: context.rootGetters['settings/getPlatformId'],
            type: 'groupOdds',
            section: 'sport',
            typegroup: 'detail',
            sport: payload.sport ? payload.sport : '',
            tournament: payload.tournament ? payload.tournament : '',
            group: payload.group,
            lang: context.rootGetters['settings/getLanguage'],
            // "product_id": (payload.status == 2) ? 1 : 0
            product_id: 1
          },
          {
            headers: {
              Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
            }
          }
        )
        .then(async res => {
          if (res.data.marketsGroups) {
            context.commit(
              'SET_MARKETS_GROUPS_DETAIL_LIVE',
              res.data.marketsGroups
            );
          }

          if (res.data.events) {
            const marketIdOrderMap = new Map();
            const marketIdOrderMobileMap = new Map();

            if (res.data.events.odds && res.data.events.odds.length > 0) {
              //res.data.events = JSON.parse(JSON.stringify(res.data.events))
              for await (const val of res.data.events.odds) {
                //res.data.events.odds.forEach((val)=>{

                if (val.markets && val.markets.length > 0) {
                  for await (const outcome of val.markets) {
                    //val.markets.forEach((outcome)=>{

                    let valueSpec = _.toString(outcome.specifiers_parsed);
                    if (!valueSpec.startsWith('-')) {
                      valueSpec = `+${valueSpec}`;
                    }
                    //console.log(outcome.name,valueSpec)

                    const sorted = _.find(outcome.outcome, { name: valueSpec });
                    if (sorted) {
                      //console.log("TROVATO",sorted,outcome.specifiers_parsed)
                      if (sorted.sort) {
                        _.assign(outcome, { sorted: sorted.sort });
                      }
                    }
                    _.assign(outcome, { spec: outcome.specifiers_parsed });
                    //outcome.spec = outcome.specifiers_parsed

                    marketIdOrderMap.set(
                      outcome._attributes.id,
                      outcome.orderInMainSection
                    );
                    marketIdOrderMobileMap.set(
                      outcome._attributes.id,
                      outcome.orderMobileInMainSection
                    );
                  }
                }
              }
            }
            const onlyManager =
              context.rootGetters['settings/getPlatformId'] == 0;
            const rules = {
              manager: context.rootGetters['rules/getRulesManager'],
              skin: !onlyManager
                ? context.rootGetters['rules/getRulesSkin']
                : [],
              lang: context.rootGetters['settings/getLanguage']
            };

            const producer = 1;
            const data_event = await eventsOddsHandler.refactorDetail(
              res.data,
              rules,
              producer,
              onlyManager,
              payload.source
            );

            const marketOrder = [];
            const marketMobileOrder = [];

            for (const key of marketIdOrderMap.keys()) {
              const obj = {
                marketId: key,
                sort: marketIdOrderMap.get(key)
              };
              marketOrder.push(obj);
            }

            for (const key of marketIdOrderMobileMap.keys()) {
              const obj = {
                marketId: key,
                sort: marketIdOrderMobileMap.get(key)
              };
              marketMobileOrder.push(obj);
            }

            await context.dispatch(
              'marketview/setMarketOrderForEventDetailLive',
              marketOrder,
              { root: true }
            );
            await context.dispatch(
              'marketview/setMobileMarketOrderForEventDetailLive',
              marketMobileOrder,
              { root: true }
            );

            /**
             * Rimozione ordinamento market enzo
             */
            // let reindex = []
            // if(_.size(data_event.event.odds)>0){
            //
            //     let markets = _.groupBy(data_event.event.odds,"id_market");
            //     for (const [key, value] of Object.entries(markets)) {
            //
            //         let valOrd = value;
            //         valOrd =_.orderBy(valOrd, ['sorted','spec'], ['asc','asc']);
            //         reindex.push(...valOrd)
            //         //   console.log("2",value)
            //     }
            //
            // }
            // if(reindex.length>0){
            //     data_event.event.odds=reindex
            // }
            /**
             * Fine Rimozione ordinamento market enzo
             */
            // console.log(data_event)
            context.commit('SET_EVENT_LIVE_DETAIL', []);
            context.commit('ADD_EVENT_LIVE_DETAIL', data_event);
            await context.dispatch(
              'marketview/updateMarketsMapSizeButtonsDetailLive',
              res.data.mapSizeButtons,
              { root: true }
            );
          } else {
            // Todo no events
            const data_events = {
              tournament: {
                ...res.data.tournament[0]
              },
              message: {
                num_events: 0
              }
            };

            context.commit('ADD_EVENT_LIVE_DETAIL', data_events);
          }
        });
    }
  },

  async fetchOddsGroupLiveDetail(context, payload) {
    await axios
      .post(
        `${context.rootGetters['settings/getUrlApi']}/events/getodds/tournament/event`,
        {
          event: payload.source,
          platform: context.rootGetters['settings/getPlatformId'],
          type: 'groupOdds',
          section: 'sport',
          typegroup: 'detail',
          sport: payload.sport ? payload.sport : '',
          tournament: payload.tournament ? payload.tournament : '',
          group: +payload.group,
          product_id: 1,
          lang: context.rootGetters['settings/getLanguage']
          // "product_id": (payload.status == 2) ? 1 : 0
        },
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
          }
        }
      )
      .then(async res => {
        if (res.data.events) {
          if (res.data.events.odds && res.data.events.odds.length > 0) {
            //res.data.events = JSON.parse(JSON.stringify(res.data.events))
            for await (const val of res.data.events.odds) {
              //res.data.events.odds.forEach((val)=>{

              if (val.markets && val.markets.length > 0) {
                for await (const outcome of val.markets) {
                  //val.markets.forEach((outcome)=>{

                  let valueSpec = _.toString(outcome.specifiers_parsed);
                  if (!valueSpec.startsWith('-')) {
                    valueSpec = `+${valueSpec}`;
                  }
                  //console.log(outcome.name,valueSpec)

                  const sorted = _.find(outcome.outcome, { name: valueSpec });
                  if (sorted) {
                    //console.log("TROVATO",sorted,outcome.specifiers_parsed)
                    if (sorted.sort) {
                      _.assign(outcome, { sorted: sorted.sort });
                    }
                  }
                  _.assign(outcome, { spec: outcome.specifiers_parsed });
                  //outcome.spec = outcome.specifiers_parsed
                }
              }
            }
          }
          const onlyManager =
            context.rootGetters['settings/getPlatformId'] == 0;
          const rules = {
            manager: context.rootGetters['rules/getRulesManager'],
            skin: !onlyManager ? context.rootGetters['rules/getRulesSkin'] : [],
            lang: context.rootGetters['settings/getLanguage']
          };

          const producer = 1;
          const data_event = await eventsOddsHandler.refactorDetail(
            res.data,
            rules,
            producer,
            onlyManager,
            payload.source
          );
          const reindex = [];
          if (_.size(data_event.event.odds) > 0) {
            const markets = _.groupBy(data_event.event.odds, 'id_market');
            for (const [key, value] of Object.entries(markets)) {
              let valOrd = value;
              valOrd = _.orderBy(valOrd, ['sorted', 'spec'], ['asc', 'asc']);
              reindex.push(...valOrd);
              //   console.log("2",value)
            }
          }
          if (reindex.length > 0) {
            data_event.event.odds = reindex;
          }
          context.commit('UPDATE_ODDS_EVENT_LIVE_DETAIL', data_event);
        } else {
          // Todo no events
          const data_events = {
            tournament: {
              ...res.data.tournament[0]
            },
            message: {
              num_events: 0
            }
          };

          context.commit('ADD_EVENT_DETAIL', data_events);
        }
      });
  },
  async fetchEventBestPlayed(context, payload) {
    if (context.rootGetters['settings/getGameConsole'] === 'marketview') {
      //console.log('market view console selected')
      context.dispatch('odds/fetchEventBestPlayedV2', payload, { root: true });
    } else {
      //console.log('default console selected')
      context.dispatch('odds/fetchEventBestPlayedV1', payload, { root: true });
    }
  },
  async fetchEventBestPlayedV1(context, payload) {
    //console.log("PAYLOA",payload)

    let sport_id = null;

    if (payload.sport_id != null) {
      sport_id = payload.sport_id;
    }

    const request = {
      sport: payload.sport,
      language_user:
        payload != undefined && payload.language_user != undefined
          ? payload.language_user
          : undefined,
      forceDefaultGameConsole:
        payload.forceDefaultGameConsole != null
          ? payload.forceDefaultGameConsole
          : null,
      groupOddsWithSpreads:
        payload.groupOddsWithSpreads != null
          ? payload.groupOddsWithSpreads
          : false,
      mobilePlatform:
        payload.mobilePlatform != null ? payload.mobilePlatform : false //note can take from there the mobileplatform instead pass parameter
    };

    return axios
      .post(
        `${context.rootGetters['settings/getUrlApi']}/events/get-best-played`,
        request,
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
          }
        }
      )
      .then(async res => {
        if (res.data.result.length > 0) {
          const count = JSON.parse(JSON.stringify(res.data.result));
          const onlyManager =
            context.rootGetters['settings/getPlatformId'] == 0;
          const rules = {
            manager: context.rootGetters['rules/getRulesManager'],
            skin: !onlyManager ? context.rootGetters['rules/getRulesSkin'] : [],
            lang: context.rootGetters['settings/getLanguage']
          };

          const producer = 0;

          // console.log('Result: ', res.data.result)

          const count_with_rules = filter(count, function (o) {
            return o.status_rule != false;
          });
          // console.log('enzo')

          const events_preview_events_best_played =
            await eventsOddsHandler.refactorEventsBestPlayed(
              res.data.result,
              rules,
              producer,
              onlyManager,
              payload.group,
              res.data.headerSign
            );

          // console.log('prova:', events_preview_events_best_played)

          forEachLodash(count_with_rules, count => {
            delete count.events;
          });
          //console.log("events_filtered",events_preview_events_best_played)
          if (_.size(events_preview_events_best_played) > 0) {
            var events_filtered = filter(
              events_preview_events_best_played,
              ev => {
                //if(ev.events && _.isArray(ev.events) && _.size(ev.events)>0) {
                return (
                  ev.sport.status == true &&
                  ev.category.status == true &&
                  ev.tournament.status == true &&
                  ev.events[0].status == 1
                );
                //}
              }
            );
          } else {
            events_filtered = [];
          }

          // console.log(events_filtered)
          context.commit('SET_COUNT_EVENTS_BEST_PLAYED', count_with_rules);
          context.commit('SET_PREVIEW_EVENTS_BEST_PLAYED', []);
          context.commit('SET_PREVIEW_EVENTS_BEST_PLAYED', events_filtered);
          // forEachLodash(events_preview_live, (tourn) =>{
          //     context.commit('ADD_PREVIEW_NEXT_EVENTS', tourn)
          // })
        }

        //todo check if headerSign is null or [] , look when normal platform is set, what return
        const headerSign = res.data.headerSign;

        if (headerSign != null) {
          await context.dispatch(
            'marketview/updateSpreadsListAndSpreadSelected',
            {
              type: 'eventBestPlayed',
              headerSign: headerSign,
              sport: payload.sport,
              events: res.data.result[0].events
            },
            { root: true }
          );
        }

        return;
      })
      .catch(error => {
        console.log(error);
      });
  },

  async fetchEventBestPlayedV2(context, payload) {
    let sport_id = null;

    if (payload.sport_id != null) {
      sport_id = payload.sport_id;
    }

    const request = {
      sport: payload.sport,
      language_user:
        payload != undefined && payload.language_user != undefined
          ? payload.language_user
          : undefined,
      forceDefaultGameConsole:
        payload.forceDefaultGameConsole != null
          ? payload.forceDefaultGameConsole
          : null,
      groupOddsWithSpreads:
        payload.groupOddsWithSpreads != null
          ? payload.groupOddsWithSpreads
          : false,
      mobilePlatform:
        payload.mobilePlatform != null ? payload.mobilePlatform : false //note can take from there the mobileplatform instead pass parameter
    };

    return axios
      .post(
        `${context.rootGetters['settings/getUrlApi']}/events/get-best-played-v2`,
        request,
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
          }
        }
      )
      .then(async res => {
        if (res.data.result.length > 0) {
          const count = JSON.parse(JSON.stringify(res.data.result));
          const onlyManager =
            context.rootGetters['settings/getPlatformId'] == 0;
          const rules = {
            manager: context.rootGetters['rules/getRulesManager'],
            skin: !onlyManager ? context.rootGetters['rules/getRulesSkin'] : [],
            lang: context.rootGetters['settings/getLanguage']
          };

          const producer = 0;

          // console.log('Result: ', res.data.result)

          const count_with_rules = filter(count, function (o) {
            return o.status_rule != false;
          });
          // console.log('enzo')

          const events_preview_events_best_played =
            await eventsOddsHandler.refactorEventsBestPlayed(
              res.data.result,
              rules,
              producer,
              onlyManager,
              payload.group,
              res.data.headerSign
            );

          // console.log('prova:', events_preview_events_best_played)

          forEachLodash(count_with_rules, count => {
            delete count.events;
          });
          //console.log("events_filtered",events_preview_events_best_played)
          if (_.size(events_preview_events_best_played) > 0) {
            var events_filtered = filter(
              events_preview_events_best_played,
              ev => {
                //if(ev.events && _.isArray(ev.events) && _.size(ev.events)>0) {
                return (
                  ev.sport.status == true &&
                  ev.category.status == true &&
                  ev.tournament.status == true &&
                  ev.events[0].status == 1
                );
                //}
              }
            );
          } else {
            events_filtered = [];
          }

          if (
            events_preview_events_best_played.length === 0 &&
            payload.sport === FOOTBALL_SPORT_ID
          ) {
            context.commit('SET_HIDE_BEST_PLAYED_WIDGET', true);
          } else {
            context.commit('SET_HIDE_BEST_PLAYED_WIDGET', false);
          }

          // console.log(events_filtered)
          context.commit('SET_COUNT_EVENTS_BEST_PLAYED', count_with_rules);
          context.commit('SET_PREVIEW_EVENTS_BEST_PLAYED', []);
          context.commit('SET_PREVIEW_EVENTS_BEST_PLAYED', events_filtered);
          // forEachLodash(events_preview_live, (tourn) =>{
          //     context.commit('ADD_PREVIEW_NEXT_EVENTS', tourn)
          // })

          //todo check if headerSign is null or [] , look when normal platform is set, what return
          const headerSign = res.data.headerSign;

          if (headerSign != null) {
            await context.dispatch(
              'marketview/updateSpreadsListAndSpreadSelected',
              {
                type: 'eventBestPlayed',
                headerSign: headerSign,
                sport: payload.sport,
                events: res.data.result[0].events
              },
              { root: true }
            );
          }
        } else {
          context.commit('SET_COUNT_EVENTS_BEST_PLAYED', 0);
          context.commit('SET_PREVIEW_EVENTS_BEST_PLAYED', []);
        }

        const bestPlayedSports = res.data.bestPlayedSports;
        if (bestPlayedSports != null) {
          await context.dispatch(
            'sport/setSportsBestPlayedAct',
            bestPlayedSports,
            { root: true }
          );
        }

        return;
      })
      .catch(error => {
        console.log(error);

        context.commit('SET_COUNT_EVENTS_BEST_PLAYED', 0);
        context.commit('SET_PREVIEW_EVENTS_BEST_PLAYED', []);
      });
  },
  async fetchAntepost(context, payload) {
    if (!state.tournaments_active.includes(payload.source)) {
      context.commit('ADD_TOURNAMENTS_ACTIVE', payload.source);

      await axios
        .post(
          `${context.rootGetters['settings/getUrlApi']}/events/getodds/antepost/event`,
          {
            event: +payload.idEvent,
            platform: context.rootGetters['settings/getPlatformId'],
            type: payload.type
          },
          {
            headers: {
              Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
            }
          }
        )
        .then(async res => {
          if (res.data.events) {
            const onlyManager =
              context.rootGetters['settings/getPlatformId'] == 0;
            const rules = {
              manager: context.rootGetters['rules/getRulesManager'],
              skin: !onlyManager
                ? context.rootGetters['rules/getRulesSkin']
                : [],
              lang: context.rootGetters['settings/getLanguage']
            };

            const producer = '0';
            const data_event = await eventsOddsHandler.refactorPreviewAntepost(
              res.data,
              rules,
              producer,
              onlyManager,
              payload.idEvent
            );
            // console.log(data_event)
            context.commit('ADD_EVENT_DETAIL', data_event);
          } else {
            // Todo no events
            const data_events = {
              tournament: {
                ...res.data.tournament[0]
              },
              message: {
                num_events: 0
              }
            };

            context.commit('ADD_EVENT_DETAIL', data_events);
          }
        });
    }
  },
  async fetchSettingsGroupsMarket(context, payload) {
    //console.log('entered in fetchSettingsGroupsMarket')

    const sport_id = payload.sport;
    if (sport_id == null) {
      //todo check this before close the feature
      // console.log('sport_id is null')
      // console.log('returning')
      return;
    }

    const groupMarketObj = state.configuredGroupsMarkets.some(
      settingGroupMarket =>
        settingGroupMarket.sport_id === payload.sport &&
        settingGroupMarket.sportId === payload.sportId &&
        settingGroupMarket.categoryId === payload.categoryId &&
        settingGroupMarket.tournamentId === payload.tournamentId
    );

    if (groupMarketObj == false) {
      // if i have not this configuration stored in the store, call rocky api
      // NOTE:   am not calling again rocky api for get data that i have
      // call rocky api for take setting group for this sport category (example Football, BasketBall...)

      // console.log('[DEBUG] axios call to /settings/sport/groupoddsmarkets/lists')
      await axios
        .post(
          `${context.rootGetters['settings/getUrlApi']}/settings/sport/groupoddsmarkets/lists`,
          {
            section: 'sport',
            sport_id: payload.sport,
            lang: payload.lang,
            product_id: payload.product_id,
            platform: payload.platform,
            type: payload.type,
            sportId: payload.sportId,
            tournamentId: payload.tournamentId,
            categoryId: payload.categoryId
          },
          {
            headers: {
              Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
            }
          }
        )
        .then(async res => {
          let data_to_save = [];

          if (res.data != null) {
            data_to_save = res.data;
            await context.dispatch(
              'marketview/updateMarketsMapSizeButtonsDetailPrematch',
              res.data.mapSizeButtons,
              { root: true }
            );
          }
          context.commit('addGroupsMarketsObject', {
            sport_id: payload.sport,
            sportId: payload.sportId,
            categoryId: payload.categoryId,
            tournamentId: payload.tournamentId,
            data: data_to_save
          });
        })
        .catch(error => {
          console.log('[ERROR] Failed to get configured groups markets');
          console.log(error);
        });
    }
  },

  async fetchActiveMarketsForMobile(context, payload) {
    const sport_id = payload.sport;
    if (sport_id == null) {
      return;
    }

    const mobileMarketsActive = context.rootGetters[
      'marketview/getPreviewMarketsEnabledForMobile'
    ].some(
      marketEnabled =>
        marketEnabled.tournamentId == payload.tournamentId &&
        marketEnabled.sportId == payload.sportId
    );

    if (mobileMarketsActive == false) {
      await axios
        .post(
          `${context.rootGetters['settings/getUrlApi']}/settings/sport/markets/mobile/activelist`,
          {
            section: 'sport',
            sport_id: payload.sport,
            lang: payload.lang,
            product_id: payload.product_id,
            platform: payload.platform,
            type: payload.type,
            sportId: payload.sportId,
            tournamentId: payload.tournamentId,
            categoryId: payload.categoryId
          },
          {
            headers: {
              Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
            }
          }
        )
        .then(async res => {
          let data_to_save = [];

          if (res.data != null) {
            data_to_save = res.data;
            const obj = {
              sportId: payload.sportId,
              sport_id: payload.sport,
              tournamentId: payload.tournamentId,
              data: res.data
            };
            await context.dispatch(
              'marketview/addPreviewMarketEnabledForMobile',
              obj,
              { root: true }
            );
          }
        })
        .catch(error => {
          console.log('[ERROR] Failed to get configured groups markets');
          console.log(error);
        });
    }
  },

  async fetchOddsGroupDetail(context, payload) {
    await axios
      .post(
        `${context.rootGetters['settings/getUrlApi']}/events/getodds/tournament/event`,
        {
          event: payload.source,
          platform: context.rootGetters['settings/getPlatformId'],
          type: 'groupOdds',
          section: 'sport',
          typegroup: 'detail',
          sport: payload.sport ? payload.sport : '',
          tournament: payload.tournament ? payload.tournament : '',
          group: +payload.group,
          product_id: 0,
          lang: context.rootGetters['settings/getLanguage']
          // "product_id": (payload.status == 2) ? 1 : 0
        },
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
          }
        }
      )
      .then(async res => {
        if (res.data.events) {
          if (res.data.events.odds && res.data.events.odds.length > 0) {
            //res.data.events = JSON.parse(JSON.stringify(res.data.events))
            for await (const val of res.data.events.odds) {
              //res.data.events.odds.forEach((val)=>{

              if (val.markets && val.markets.length > 0) {
                for await (const outcome of val.markets) {
                  //val.markets.forEach((outcome)=>{

                  let valueSpec = _.toString(outcome.specifiers_parsed);
                  if (!valueSpec.startsWith('-')) {
                    valueSpec = `+${valueSpec}`;
                  }
                  //console.log(outcome.name,valueSpec)

                  const sorted = _.find(outcome.outcome, { name: valueSpec });
                  if (sorted) {
                    //console.log("TROVATO",sorted,outcome.specifiers_parsed)
                    if (sorted.sort) {
                      _.assign(outcome, { sorted: sorted.sort });
                    }
                  }
                  _.assign(outcome, { spec: outcome.specifiers_parsed });
                  //outcome.spec = outcome.specifiers_parsed
                }
              }
            }
          }

          const onlyManager =
            context.rootGetters['settings/getPlatformId'] == 0;
          const rules = {
            manager: context.rootGetters['rules/getRulesManager'],
            skin: !onlyManager ? context.rootGetters['rules/getRulesSkin'] : [],
            lang: context.rootGetters['settings/getLanguage']
          };

          const producer = 0;

          const data_event = await eventsOddsHandler.refactorDetail(
            res.data,
            rules,
            producer,
            onlyManager,
            payload.source
          );

          const reindex = [];
          if (_.size(data_event.event.odds) > 0) {
            const markets = _.groupBy(data_event.event.odds, 'id_market');
            for (const [key, value] of Object.entries(markets)) {
              let valOrd = value;
              valOrd = _.orderBy(valOrd, ['sorted', 'spec'], ['asc', 'asc']);
              reindex.push(...valOrd);
              //   console.log("2",value)
            }
          }
          if (reindex.length > 0) {
            data_event.event.odds = reindex;
          }
          // console.log(data_event.event.odds)
          context.commit('UPDATE_ODDS_EVENT_DETAIL', data_event);
        } else {
          // Todo no events
          const data_events = {
            tournament: {
              ...res.data.tournament[0]
            },
            message: {
              num_events: 0
            }
          };

          context.commit('ADD_EVENT_DETAIL', data_events);
        }
      });
  },
  async fetchOddsGroupDetailV2(context, payload) {
    // console.log('fetchOddsGroupDetailV2 action !!!!')

    await axios
      .post(
        `${context.rootGetters['settings/getUrlApi']}/events/getodds/tournament/event-v2`,
        {
          event: payload.source,
          platform: context.rootGetters['settings/getPlatformId'],
          type: 'groupOdds',
          section: 'sport',
          typegroup: 'detail',
          sport: payload.sport ? payload.sport : '',
          tournament: payload.tournament ? payload.tournament : '',
          group: payload.group,
          product_id: 0,
          lang: context.rootGetters['settings/getLanguage']
          // "product_id": (payload.status == 2) ? 1 : 0
        },
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
          }
        }
      )
      .then(async res => {
        if (res.data.events) {
          const marketIdOrderMap = new Map();
          const marketIdOrderMobileMap = new Map();

          if (res.data.events.odds && res.data.events.odds.length > 0) {
            //res.data.events = JSON.parse(JSON.stringify(res.data.events))
            for await (const val of res.data.events.odds) {
              //res.data.events.odds.forEach((val)=>{

              if (val.markets && val.markets.length > 0) {
                for await (const outcome of val.markets) {
                  //val.markets.forEach((outcome)=>{

                  let valueSpec = _.toString(outcome.specifiers_parsed);
                  if (!valueSpec.startsWith('-')) {
                    valueSpec = `+${valueSpec}`;
                  }
                  //console.log(outcome.name,valueSpec)

                  const sorted = _.find(outcome.outcome, { name: valueSpec });
                  if (sorted) {
                    //console.log("TROVATO",sorted,outcome.specifiers_parsed)
                    if (sorted.sort) {
                      _.assign(outcome, { sorted: sorted.sort });
                    }
                  }
                  _.assign(outcome, { spec: outcome.specifiers_parsed });
                  //outcome.spec = outcome.specifiers_parsed

                  marketIdOrderMap.set(
                    outcome._attributes.id,
                    outcome.orderInMainSection
                  );
                  marketIdOrderMobileMap.set(
                    outcome._attributes.id,
                    outcome.orderMobileInMainSection
                  );
                }
              }
            }
          }

          const onlyManager =
            context.rootGetters['settings/getPlatformId'] == 0;
          const rules = {
            manager: context.rootGetters['rules/getRulesManager'],
            skin: !onlyManager ? context.rootGetters['rules/getRulesSkin'] : [],
            lang: context.rootGetters['settings/getLanguage']
          };

          const producer = 0;

          const data_event = await eventsOddsHandler.refactorDetail(
            res.data,
            rules,
            producer,
            onlyManager,
            payload.source
          );

          const marketOrder = [];
          const marketMobileOrder = [];

          for (const key of marketIdOrderMap.keys()) {
            const obj = {
              marketId: key,
              sort: marketIdOrderMap.get(key)
            };
            marketOrder.push(obj);
          }

          for (const key of marketIdOrderMobileMap.keys()) {
            const obj = {
              marketId: key,
              sort: marketIdOrderMobileMap.get(key)
            };
            marketMobileOrder.push(obj);
          }

          await context.dispatch(
            'marketview/setMarketOrderForEventDetail',
            marketOrder,
            { root: true }
          );
          await context.dispatch(
            'marketview/setMobileMarketOrderForEventDetail',
            marketMobileOrder,
            { root: true }
          );

          const reindex = [];
          // if (_.size(data_event.event.odds) > 0) {
          //
          //     let markets = _.groupBy(data_event.event.odds, "id_market");
          //     for (const [key, value] of Object.entries(markets)) {
          //
          //         let valOrd = value;
          //         // valOrd = _.orderBy(valOrd, ['sorted', 'spec'], ['asc', 'asc']);
          //          valOrd = _.orderBy(valOrd, ['orderInMainSection', 'internalSort'], ['asc', 'asc']);
          //         reindex.push(...valOrd)
          //         //   console.log("2",value)
          //     }
          //
          // }
          if (reindex.length > 0) {
            data_event.event.odds = reindex;
          }
          //  console.log(data_event.event.odds)
          // console.log('updating odds_event_detail')

          const eventDetailInfo = {
            event: payload.source,
            platform: context.rootGetters['settings/getPlatformId'],
            sport: payload.sport ? payload.sport : '',
            tournament: payload.tournament ? payload.tournament : '',
            group: payload.group,
            lang: context.rootGetters['settings/getLanguage'],
            tab: payload.tab
          };
          localStorage.setItem('event-detail', JSON.stringify(eventDetailInfo));

          context.commit('UPDATE_ODDS_EVENT_DETAIL', data_event);
          await context.dispatch(
            'marketview/updateMarketsMapSizeButtonsDetailPrematch',
            res.data.mapSizeButtons,
            { root: true }
          );

          if (res.data.combinableMarkets != null) {
            context.commit(
              'cart/ADD_COMBINABLE_MARKETS',
              res.data.combinableMarkets,
              { root: true }
            );
          }
        } else {
          // console.log('no events committing')

          // Todo no events
          const data_events = {
            tournament: {
              ...res.data.tournament[0]
            },
            message: {
              num_events: 0
            }
          };

          context.commit('ADD_EVENT_DETAIL', data_events);
          await context.dispatch(
            'marketview/updateMarketsMapSizeButtonsDetailPrematch',
            res.data.mapSizeButtons,
            { root: true }
          );
        }
      });
  },
  async fetchLive(context, payload) {
    let request = {};

    if (
      size(context.state.live_sport_selected) > 0 &&
      context.state.live_sport_selected &&
      context.state.live_sport_selected.sport_id &&
      context.state.live_sport_selected.sport
    ) {
      request = {
        sport_id: context.state.live_sport_selected.sport_id,
        sport: context.state.live_sport_selected.sport,
        lang: context.rootGetters['settings/getLanguage']
      };
    } else {
      request = {
        sport_id:
          payload != undefined && payload.sport_id != undefined
            ? payload.sport_id
            : undefined,
        sport:
          payload != undefined && payload.sport != undefined
            ? payload.sport
            : undefined,
        lang: context.rootGetters['settings/getLanguage']
      };
    }

    let endpoint_live;

    const platformId = +context.rootGetters['settings/getPlatformId'];

    if (
      context.rootGetters['settings/getGameConsole'] === 'marketview' &&
      (platformId === 54 || platformId === 99)
    ) {
      //todo this is a temporary test please delete as soon as is possible
      endpoint_live = 'get-events-count-sport-v2';
    } else {
      endpoint_live = 'get-events-count-sport';
    }

    return axios
      .post(
        `${context.rootGetters['settings/getUrlApi']}/live-events/${endpoint_live}`,
        request,
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
          }
        }
      )
      .then(async res => {
        if (res.data.result.length > 0) {
          let ordered_live = [];

          let count = JSON.parse(JSON.stringify(res.data.result));
          count = _.filter(count, el => {
            return !el.sport.status_rule || el.sport.status_rule == true;
          });

          const count_with_rules = filter(count, function (o) {
            return o.status_rule != false;
          });

          const onlyManager =
            context.rootGetters['settings/getPlatformId'] == 0;
          const rules = {
            manager: context.rootGetters['rules/getRulesManager'],
            skin: !onlyManager ? context.rootGetters['rules/getRulesSkin'] : [],
            lang: context.rootGetters['settings/getLanguage']
          };

          const producer = 1;

          let elements;
          if (!request.sport) {
            elements = res.data.result[0];
          } else {
            elements = _.find(res.data.result, {
              sport: { id: request.sport }
            });
          }

          // console.log("EVENETS",elements.events)
          if (_.size(elements.events) > 0) {
            const events_preview_live = await eventsOddsHandler.refactorLive(
              res.data.result,
              rules,
              producer,
              onlyManager,
              payload.group
            );
            // console.log("events_preview_live",events_preview_live)

            // var count_with_rules = filter(count, function (o) {
            //     return o.status_rule != false
            // });
            // console.log("count_with_rules",count_with_rules)
            // console.log('events_preview_live')
            // console.log(events_preview_live)
            //var ordered_live = orderBy(events_preview_live, ['category.order', 'category.name'], ['asc', 'asc']);
            //var ordered_live = orderBy(events_preview_live, ['categoryOrder', 'category.name'], ['asc', 'asc']);
            ordered_live = orderBy(
              events_preview_live,
              ['categoryOrder', 'category.name', 'tournamentOrder'],
              ['asc', 'asc', 'asc']
            );
            // console.log("ordered_live",ordered_live)

            count_with_rules.forEach(count => {
              delete count.events;
            });

            context.commit('SET_COUNT_LIVE', count_with_rules);
            context.commit('SET_PREVIEW_LIVE', []);

            const disabled = context.rootGetters['rules/getRulesDisabled'];
            if (disabled && _.isArray(disabled) && _.size(disabled) > 0) {
              for (const eventino of ordered_live) {
                if (
                  eventino.events &&
                  _.isArray(eventino.events) &&
                  _.size(eventino.events) > 0
                ) {
                  var newElements = [];
                  eventino.events.forEach((event, key) => {
                    /*console.log("Value",event)
                                        console.log("key",key)*/
                    if (
                      event.id &&
                      _.isNumber(event.id) &&
                      !_.includes(disabled, +event.id) &&
                      _.isObject(event) &&
                      !_.isUndefined(event)
                    ) {
                      //console.log(event)
                      newElements.push(event);
                    }
                  });
                  eventino.events = newElements;
                }
              }
            }
            context.commit('SET_PREVIEW_LIVE', ordered_live);

            if (res.data.enabledSocketSettlementOddLive) {
              await context.dispatch(
                'socket/setEnabledSocketSettlementOddLive',
                res.data.enabledSocketSettlementOddLive,
                { root: true }
              );
            }

            if (res.data.shiftOutcomeAlreadyDefined) {
              await context.dispatch(
                'socket/setShiftOutcomeAlreadyDefined',
                res.data.shiftOutcomeAlreadyDefined,
                { root: true }
              );
            }
          } else {
            context.commit('SET_COUNT_LIVE', count_with_rules);
            context.commit('SET_PREVIEW_LIVE', ordered_live);
          }
        } else {
          context.commit('SET_COUNT_LIVE', []);
          context.commit('SET_PREVIEW_LIVE', []);
        }
      })
      .catch(error => {
        console.log(error);
        console.log(error.message);
        console.log(error.stack);
      });
  },

  async fetchPreview(context, payload) {
    // todo think to disable again the code about disable banner
    let disableBanner = true;

    if (
      (payload.featuredTournament != null &&
        payload.featuredTournament === true) ||
      (payload.isVisitedTournamentFromLocalStorage != null &&
        payload.isVisitedTournamentFromLocalStorage === true)
    ) {
      disableBanner = false;
    }

    if (disableBanner) {
      await context.dispatch('settings/setStatusBannerCentral', false, {
        root: true
      });
    }

    if (context.rootGetters['settings/getGameConsole'] === 'marketview') {
      await context.dispatch('odds/fetchPreviewV2', payload, { root: true });
    } else {
      await context.dispatch('odds/fetchPreviewV1', payload, { root: true });
    }
  },

  async fetchPreviewV1(context, payload) {
    //payload = payload.payload;

    context.commit('SET_FEATURED_TOURNAMENTS', []);
    context.commit(
      'REMOVE_FEATURED_TOURNAMENTS_SOURCES_FROM_TOURNAMENT_ACTIVES',
      null
    );
    context.commit('SET_IS_A_FIRST_LOAD_FOR_FEATURED_TOURNAMENT', false);

    if (!state.tournaments_active.includes(payload.source)) {
      context.commit('ADD_TOURNAMENTS_ACTIVE', payload.source);

      await axios
        .post(
          `${context.rootGetters['settings/getUrlApi']}/events/getodds/tournament/preview`,
          {
            tournament: payload.tournament,
            platform: context.rootGetters['settings/getPlatformId'],
            type: payload.type,
            section: 'sport',
            //"sport": payload.sport,
            filter: context.rootGetters['tree/getFilter'],
            lang: context.rootGetters['settings/getLanguage'],
            sportId: payload.sportId,
            forceDefaultGameConsole:
              payload.forceDefaultGameConsole != null
                ? payload.forceDefaultGameConsole
                : null,
            mobilePlatform:
              payload.mobilePlatform != null ? payload.mobilePlatform : false,
            groupOddsWithSpreads:
              payload.groupOddsWithSpreads != null
                ? payload.groupOddsWithSpreads
                : false
          },
          {
            headers: {
              Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
            }
          }
        )
        .then(async res => {
          if (res.data.events.length > 0) {
            const onlyManager =
              context.rootGetters['settings/getPlatformId'] == 0;
            const rules = {
              manager: context.rootGetters['rules/getRulesManager'],
              skin: !onlyManager
                ? context.rootGetters['rules/getRulesSkin']
                : [],
              lang: context.rootGetters['settings/getLanguage']
            };

            const producer = 0;

            //todo check if headerSign is null or [] , look when normal platform is set, what return
            const headerSign = res.data.headerSign;

            if (headerSign != null) {
              await context.dispatch(
                'marketview/updateSpreadsListAndSpreadSelected',
                {
                  type: 'preview',
                  headerSign: headerSign,
                  tournamentId: payload.tournament,
                  events: res.data.events
                },
                { root: true }
              );
            }

            const data_events = await eventsOddsHandler.refactorPreview(
              res.data,
              rules,
              producer,
              onlyManager,
              payload.source
            );
            // console.log("data_events",data_events)
            // console.log(payload.mode)
            if (payload.mode == 'reverse') {
              context.commit('ADD_PREVIEW_REVERSE', data_events);
            } else if (payload.mode == 'substitute') {
              context.commit('REPLACE_PREVIEW', data_events);
            } else {
              context.commit('ADD_PREVIEW', data_events);
            }

            if (res.data.gameConsole != null) {
              context.commit(
                'settings/SET_GAME_CONSOLE',
                res.data.gameConsole,
                { root: true }
              );
            }

            if (
              res.data.gameConsole != null &&
              res.data.gameConsole == 'marketview'
            ) {
              context.commit('SET_PREVIEW_TYPE_VIEW', {
                tournamentId: payload.tournament,
                typeView: 'extended'
              });

              context.commit('SET_SIZE_ODD_BUTTON', {
                tournamentId: payload.tournament,
                sizeOddsButtons: {
                  sizeOddButtonMd: 'md-2',
                  sizeOddButtonLg: 'lg-2',
                  sizeOddButtonXl: 'xl-2'
                }
              });
            }

            context.commit('SET_EVENT_DETAIL', []);
            context.commit('SET_EVENTS_DETAIL_ACTIVE', []);
            context.dispatch('removeAntepostActive');
            return;
          } else {
            context.dispatch('settings/setSnackbar', true, { root: true });
            context.dispatch(
              'settings/setSnackbarText',
              'eventsNoLongerAvailable',
              { root: true }
            );
            return;
          }
        });
    }
  },

  async fetchPreviewV2(context, payload) {
    // todo check if am still using this

    const isMobile =
      payload.mobilePlatform != null ? payload.mobilePlatform : false;

    context.commit('SET_FEATURED_TOURNAMENTS', []);
    context.commit(
      'REMOVE_FEATURED_TOURNAMENTS_SOURCES_FROM_TOURNAMENT_ACTIVES',
      null
    );
    context.commit('SET_IS_A_FIRST_LOAD_FOR_FEATURED_TOURNAMENT', false);

    //payload = payload.payload;

    const forceCallApi =
      payload.forceCallApi != null ? payload.forceCallApi : false;

    if (
      !state.tournaments_active.includes(payload.source) ||
      forceCallApi === true
    ) {
      if (isMobile === true) {
        context.commit('SET_TOURNAMENTS_ACTIVE', []);
        context.commit('setMarketsGroupsIdActive', []);
        context.commit('setMarketsIdActive', []);
      }

      context.commit('ADD_TOURNAMENTS_ACTIVE', payload.source);

      window.parent.postMessage(
        {
          type: 'tournamentOpened',
          sportId: payload.sportId,
          tournamentId: payload.tournament,
          sportName: payload.sportName != null ? payload.sportName : 'sport',
          tournamentName:
            payload.tournamentName != null
              ? payload.tournamentName
              : 'tournament'
        },
        '*'
      );

      await axios
        .post(
          `${context.rootGetters['settings/getUrlApi']}/events/getodds/tournament/preview-v2`,
          {
            tournament: payload.tournament,
            platform: context.rootGetters['settings/getPlatformId'],
            type: payload.type,
            section: 'sport',
            //"sport": payload.sport,
            filter: context.rootGetters['treeV2/getFilter'],
            lang: context.rootGetters['settings/getLanguage'],
            sportId: payload.sportId,
            forceDefaultGameConsole:
              payload.forceDefaultGameConsole != null
                ? payload.forceDefaultGameConsole
                : null,
            mobilePlatform:
              payload.mobilePlatform != null ? payload.mobilePlatform : false,
            groupOddsWithSpreads:
              payload.groupOddsWithSpreads != null
                ? payload.groupOddsWithSpreads
                : false,
            groupId: payload.groupId
          },
          {
            headers: {
              Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
            }
          }
        )
        .then(async res => {
          if (res.data.events.length > 0) {
            const onlyManager =
              context.rootGetters['settings/getPlatformId'] == 0;
            const rules = {
              manager: context.rootGetters['rules/getRulesManager'],
              skin: !onlyManager
                ? context.rootGetters['rules/getRulesSkin']
                : [],
              lang: context.rootGetters['settings/getLanguage']
            };

            const producer = 0;

            //todo check if headerSign is null or [] , look when normal platform is set, what return
            const headerSign = res.data.headerSign;

            if (headerSign != null) {
              await context.dispatch(
                'marketview/updateSpreadsListAndSpreadSelected',
                {
                  type: 'preview',
                  headerSign: headerSign,
                  tournamentId: payload.tournament,
                  events: res.data.events
                },
                { root: true }
              );
            }

            const data_events = await eventsOddsHandler.refactorPreview(
              res.data,
              rules,
              producer,
              onlyManager,
              payload.source
            );
            // console.log("data_events",data_events)
            // console.log(payload.mode)

            if (isMobile === true) {
              context.commit(
                'REPLACE_PREVIEW_OR_ADD_IF_NOT_PRESENT',
                data_events
              );
            } else {
              if (payload.mode == 'reverse') {
                context.commit('ADD_PREVIEW_REVERSE', data_events);
              } else if (payload.mode == 'substitute') {
                context.commit('REPLACE_PREVIEW', data_events);
              } else {
                context.commit('ADD_PREVIEW', data_events);
              }
            }

            if (res.data.gameConsole != null) {
              context.commit(
                'settings/SET_GAME_CONSOLE',
                res.data.gameConsole,
                { root: true }
              );
            }

            if (
              res.data.gameConsole != null &&
              res.data.gameConsole == 'marketview'
            ) {
              context.commit('SET_PREVIEW_TYPE_VIEW', {
                tournamentId: payload.tournament,
                typeView: 'extended'
              });

              context.commit('SET_SIZE_ODD_BUTTON', {
                tournamentId: payload.tournament,
                sizeOddsButtons: {
                  sizeOddButtonMd: 'md-2',
                  sizeOddButtonLg: 'lg-2',
                  sizeOddButtonXl: 'xl-2'
                }
              });
            }

            if (res.data.combinedMarkets != null) {
              context.commit(
                'cart/ADD_COMBINABLE_MARKETS',
                res.data.combinedMarkets,
                { root: true }
              );
            }

            await context.dispatch(
              'marketview/updateMarketGroupActiveForTournament',
              {
                groupId: payload.groupId, //could be null
                tournamentId: +payload.tournament
              },
              { root: true }
            );

            context.commit('SET_EVENT_DETAIL', []);
            context.commit('SET_EVENTS_DETAIL_ACTIVE', []);
            context.dispatch('removeAntepostActive');

            // const previewTournamentInfo = {
            //     forceDefaultGameConsole: payload.forceDefaultGameConsole,
            //     groupOddsWithSpreads: payload.groupOddsWithSpreads,
            //     mobilePlatform: payload.mobilePlatform,
            //     source: payload.source,
            //     sportId: payload.sportId,
            //     tournament: payload.tournament,
            //     type: payload.type
            // }

            const now = new Date().getTime();
            const expiryTimePreview =
              new Date().getTime() +
              context.rootGetters[
                'marketview/getPreviewTournamentVisitedExpiryTimeTTL'
              ];
            // const expiryTimeJson = {
            //     expiryTime: expiryTimePreview
            // }

            // if (localStorage.getItem('preview-tournament-visited')) { // old logic with more preview tournament visited saved
            //
            //     const previewTournamentVisited = localStorage.getItem('preview-tournament-visited');
            //     const previewTournamentVisitedArray = JSON.parse(previewTournamentVisited);
            //     const found = previewTournamentVisitedArray.find((element) => element.source === payload.source);
            //
            //     if (!found) {
            //         previewTournamentVisitedArray.push(previewTournamentInfo);
            //         localStorage.setItem('preview-tournament-visited', JSON.stringify(previewTournamentVisitedArray));
            //         localStorage.setItem('preview-tournament-visited-expiry-time', JSON.stringify(expiryTimeJson));
            //     }
            // } else {
            //     localStorage.setItem('preview-tournament-visited', JSON.stringify([previewTournamentInfo]));
            //     localStorage.setItem('preview-tournament-visited-expiry-time', JSON.stringify(expiryTimeJson));
            // }

            // localStorage.setItem('preview-tournament-visited', JSON.stringify([previewTournamentInfo]));
            // localStorage.setItem('preview-tournament-visited-expiry-time', JSON.stringify(expiryTimeJson));

            const previewTournamentObj = {
              sportId: payload.sportId,
              tournamentId: payload.tournament,
              sportName:
                payload.sportName != null ? payload.sportName : 'sport',
              tournamentName:
                payload.tournamentName != null
                  ? payload.tournamentName
                  : 'tournament',
              expiryTimeJson: expiryTimePreview
            };

            if (localStorage.getItem('visited-tournament-preview')) {
              const previewTournamentVisited = localStorage.getItem(
                'visited-tournament-preview'
              );
              let previewTournamentVisitedArray = JSON.parse(
                previewTournamentVisited
              );

              previewTournamentVisitedArray =
                previewTournamentVisitedArray.filter(el => {
                  return (
                    el.expiryTimeJson > now &&
                    el.tournamentId != payload.tournament
                  );
                });
              previewTournamentVisitedArray.push(previewTournamentObj);
              localStorage.setItem(
                'visited-tournament-preview',
                JSON.stringify(previewTournamentVisitedArray)
              );
            } else {
              localStorage.setItem(
                'visited-tournament-preview',
                JSON.stringify([previewTournamentObj])
              );
            }

            return;
          } else {
            context.dispatch('settings/setSnackbar', true, { root: true });
            context.dispatch(
              'settings/setSnackbarText',
              'eventsNoLongerAvailable',
              { root: true }
            );
            context.dispatch(
              'removeFromTournamentActive',
              payload.tournament + '#prematch'
            );
            return;
          }
        })
        .catch(error => {
          console.log(error);

          context.dispatch('settings/setSnackbar', true, { root: true });
          context.dispatch(
            'settings/setSnackbarText',
            'eventsNoLongerAvailable',
            { root: true }
          );
          context.dispatch(
            'removeFromTournamentActive',
            payload.tournament + '#prematch'
          );
          return;
        });
    }
  },

  /* RULES SERVER SIDE V3 */

  async fetchPreviewV3(context, payload) {
    console.log('fetchPreviewV3: ');
    // console.log("payload", payload)

    const isMobile =
      payload.mobilePlatform != null ? payload.mobilePlatform : false;

    context.commit('SET_FEATURED_TOURNAMENTS', []);
    context.commit(
      'REMOVE_FEATURED_TOURNAMENTS_SOURCES_FROM_TOURNAMENT_ACTIVES',
      null
    );
    context.commit('SET_IS_A_FIRST_LOAD_FOR_FEATURED_TOURNAMENT', false);

    //payload = payload.payload;

    const forceCallApi =
      payload.forceCallApi != null ? payload.forceCallApi : false;

    if (
      !state.tournaments_active.includes(payload.source) ||
      forceCallApi === true
    ) {
      if (isMobile === true) {
        context.commit('SET_TOURNAMENTS_ACTIVE', []);
        context.commit('setMarketsGroupsIdActive', []);
        context.commit('setMarketsIdActive', []);
      }

      context.commit('ADD_TOURNAMENTS_ACTIVE', payload.source);

      window.parent.postMessage(
        {
          type: 'tournamentOpened',
          sportId: payload.sportId,
          tournamentId: payload.tournament,
          sportName: payload.sportName != null ? payload.sportName : 'sport',
          tournamentName:
            payload.tournamentName != null
              ? payload.tournamentName
              : 'tournament'
        },
        '*'
      );

      await axios
        .post(
          `${context.rootGetters['settings/getUrlApi']}/events/getodds/tournament/preview-v3`,
          {
            platformId: context.rootGetters['settings/getPlatformId'],
            sportId: payload.sportId,
            categoryId: payload.categoryId,
            tournamentId: payload.tournament,
            type: payload.type,
            section: 'sport',
            filter: context.rootGetters['treeV2/getFilter'],
            lang: context.rootGetters['settings/getLanguage'],
            forceDefaultGameConsole:
              payload.forceDefaultGameConsole != null
                ? payload.forceDefaultGameConsole
                : null,
            mobilePlatform:
              payload.mobilePlatform != null ? payload.mobilePlatform : false,
            groupOddsWithSpreads:
              payload.groupOddsWithSpreads != null
                ? payload.groupOddsWithSpreads
                : false,
            groupId: payload.groupId
          },
          {
            headers: {
              Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
            }
          }
        )
        .then(async res => {
          if (
            res.data.messages === 'Success Operation' &&
            res.data.events != null
          ) {
            let sportObj = {
              id: payload.sportId,
              name: res.data.sportName
            };

            let categoryObj = {
              id: payload.categoryId,
              name: res.data.categoryName
            };

            let tournamentObj = {
              id: payload.tournament,
              name: res.data.tournamentName
            };

            var onlyManager =
              context.rootGetters['settings/getPlatformId'] == 0;
            // var rules = {
            //     manager: context.rootGetters['rules/getRulesManager'],
            //     skin: (!onlyManager) ? context.rootGetters['rules/getRulesSkin'] : [],
            //     lang: context.rootGetters['settings/getLanguage']
            // }

            var producer = 0;

            //todo check if headerSign is null or [] , look when normal platform is set, what return
            let headerSign = res.data.headerSign;

            if (headerSign != null) {
              await context.dispatch(
                'marketview/updateSpreadsListAndSpreadSelectedV3',
                {
                  type: 'preview',
                  headerSign: headerSign,
                  tournamentId: payload.tournament,
                  events: res.data.events
                },
                { root: true }
              );
            }

            const data_events = await eventsOddsHandler.refactorPreviewV2(
              res.data,
              sportObj,
              categoryObj,
              tournamentObj,
              producer,
              onlyManager,
              payload.source
            );
            // console.log(payload.mode)

            if (isMobile === true) {
              context.commit(
                'REPLACE_PREVIEW_OR_ADD_IF_NOT_PRESENT',
                data_events
              );
            } else {
              if (payload.mode == 'reverse') {
                context.commit('ADD_PREVIEW_REVERSE', data_events);
              } else if (payload.mode == 'substitute') {
                context.commit('REPLACE_PREVIEW', data_events);
              } else {
                context.commit('ADD_PREVIEW', data_events);
              }
            }

            if (res.data.gameConsole != null) {
              context.commit(
                'settings/SET_GAME_CONSOLE',
                res.data.gameConsole,
                { root: true }
              );
            }

            if (
              res.data.gameConsole != null &&
              res.data.gameConsole == 'marketview'
            ) {
              context.commit('SET_PREVIEW_TYPE_VIEW', {
                tournamentId: payload.tournament,
                typeView: 'extended'
              });

              context.commit('SET_SIZE_ODD_BUTTON', {
                tournamentId: payload.tournament,
                sizeOddsButtons: {
                  sizeOddButtonMd: 'md-2',
                  sizeOddButtonLg: 'lg-2',
                  sizeOddButtonXl: 'xl-2'
                }
              });
            }

            context.dispatch(
              'marketview/updateMarketGroupActiveForTournament',
              {
                groupId: payload.groupId, //could be null
                tournamentId: +payload.tournament
              },
              { root: true }
            );

            context.commit('SET_EVENT_DETAIL', []);
            context.commit('SET_EVENTS_DETAIL_ACTIVE', []);
            context.dispatch('removeAntepostActive');

            // const previewTournamentInfo = {
            //     forceDefaultGameConsole: payload.forceDefaultGameConsole,
            //     groupOddsWithSpreads: payload.groupOddsWithSpreads,
            //     mobilePlatform: payload.mobilePlatform,
            //     source: payload.source,
            //     sportId: payload.sportId,
            //     tournament: payload.tournament,
            //     type: payload.type
            // }

            // const expiryTimePreview = new Date().getTime() + context.rootGetters['marketview/getPreviewTournamentVisitedExpiryTimeTTL']
            // const expiryTimeJson = {
            //     expiryTime: expiryTimePreview
            // }

            // if (localStorage.getItem('preview-tournament-visited')) { // old logic with more preview tournament visited saved
            //
            //     const previewTournamentVisited = localStorage.getItem('preview-tournament-visited');
            //     const previewTournamentVisitedArray = JSON.parse(previewTournamentVisited);
            //     const found = previewTournamentVisitedArray.find((element) => element.source === payload.source);
            //
            //     if (!found) {
            //         previewTournamentVisitedArray.push(previewTournamentInfo);
            //         localStorage.setItem('preview-tournament-visited', JSON.stringify(previewTournamentVisitedArray));
            //         localStorage.setItem('preview-tournament-visited-expiry-time', JSON.stringify(expiryTimeJson));
            //     }
            // } else {
            //     localStorage.setItem('preview-tournament-visited', JSON.stringify([previewTournamentInfo]));
            //     localStorage.setItem('preview-tournament-visited-expiry-time', JSON.stringify(expiryTimeJson));
            // }

            // localStorage.setItem('preview-tournament-visited', JSON.stringify([previewTournamentInfo]));
            // localStorage.setItem('preview-tournament-visited-expiry-time', JSON.stringify(expiryTimeJson));

            return;
          } else {
            context.commit('SET_PREVIEW', []);

            context.dispatch(
              'odds/showAlertEventNotAvailable',
              payload.source,
              { root: true }
            );

            return;
          }
        })
        .catch(error => {
          console.log(error);
          context.commit('SET_PREVIEW', []);

          context.dispatch('odds/showAlertEventNotAvailable', payload.source, {
            root: true
          });

          return;
        });
    }
  },

  //
  async fetchPreviewForFeaturedTournament(context, payload) {
    // todo evaluate to remove all the logics for featured tournament if not anymore used

    const forceCallApi =
      payload.forceCallApi != null ? payload.forceCallApi : false;

    if (
      !state.tournaments_active.includes(payload.source) ||
      forceCallApi === true
    ) {
      context.commit('ADD_TOURNAMENTS_ACTIVE', payload.source);

      await axios
        .post(
          `${context.rootGetters['settings/getUrlApi']}/events/getodds/tournament/preview-v2`,
          {
            tournament: payload.tournament,
            platform: context.rootGetters['settings/getPlatformId'],
            type: payload.type,
            section: 'sport',
            //"sport": payload.sport,
            filter: context.rootGetters['treeV2/getFilter'],
            lang: context.rootGetters['settings/getLanguage'],
            sportId: payload.sportId,
            forceDefaultGameConsole:
              payload.forceDefaultGameConsole != null
                ? payload.forceDefaultGameConsole
                : null,
            mobilePlatform:
              payload.mobilePlatform != null ? payload.mobilePlatform : false,
            groupOddsWithSpreads:
              payload.groupOddsWithSpreads != null
                ? payload.groupOddsWithSpreads
                : false,
            groupId: payload.groupId
          },
          {
            headers: {
              Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
            }
          }
        )
        .then(async res => {
          if (res.data.events.length > 0) {
            const onlyManager =
              context.rootGetters['settings/getPlatformId'] == 0;
            const rules = {
              manager: context.rootGetters['rules/getRulesManager'],
              skin: !onlyManager
                ? context.rootGetters['rules/getRulesSkin']
                : [],
              lang: context.rootGetters['settings/getLanguage']
            };

            const producer = 0;

            //todo check if headerSign is null or [] , look when normal platform is set, what return
            const headerSign = res.data.headerSign;

            if (headerSign != null) {
              await context.dispatch(
                'marketview/updateSpreadsListAndSpreadSelected',
                {
                  type: 'preview',
                  headerSign: headerSign,
                  tournamentId: payload.tournament,
                  events: res.data.events
                },
                { root: true }
              );
            }

            const data_events = await eventsOddsHandler.refactorPreview(
              res.data,
              rules,
              producer,
              onlyManager,
              payload.source
            );
            // console.log("data_events",data_events)
            // console.log(payload.mode)

            if (res.data.combinedMarkets != null) {
              context.commit(
                'cart/ADD_COMBINABLE_MARKETS',
                res.data.combinedMarkets,
                { root: true }
              );
            }

            if (payload.mode == 'reverse') {
              context.commit('ADD_PREVIEW_REVERSE', data_events);
              context.commit('SET_FEATURED_TOURNAMENTS', []);
              context.commit(
                'REMOVE_FEATURED_TOURNAMENTS_SOURCES_FROM_TOURNAMENT_ACTIVES',
                null
              );
              // await context.dispatch('marketview/removePreviewMarketView', null,  {root: true})
            } else if (payload.mode == 'substitute') {
              context.commit('REPLACE_PREVIEW', data_events),
                context.commit('SET_FEATURED_TOURNAMENTS', []);
              context.commit(
                'REMOVE_FEATURED_TOURNAMENTS_SOURCES_FROM_TOURNAMENT_ACTIVES',
                null
              );
              // await context.dispatch('marketview/removePreviewMarketView', null,  {root: true})
            } else if (payload.mode == 'featuredTournaments') {
              context.commit('ADD_FEATURED_TOURNAMENTS', data_events);
              context.commit(
                'ADD_FEATURED_TOURNAMENT_SOURCE_INFO',
                payload.source
              );
            } else if (payload.mode == 'replaceFeaturedTournaments') {
              context.commit('REPLACE_FEATURED_TOURNAMENTS', data_events);
            } else {
              context.commit('ADD_PREVIEW', data_events),
                context.commit('SET_FEATURED_TOURNAMENTS', []);
              context.commit(
                'REMOVE_FEATURED_TOURNAMENTS_SOURCES_FROM_TOURNAMENT_ACTIVES',
                null
              );
              //await context.dispatch('marketview/removePreviewMarketView', null,  {root: true})
            }

            if (res.data.gameConsole != null) {
              context.commit(
                'settings/SET_GAME_CONSOLE',
                res.data.gameConsole,
                { root: true }
              );
            }

            if (
              res.data.gameConsole != null &&
              res.data.gameConsole == 'marketview'
            ) {
              context.commit('SET_PREVIEW_TYPE_VIEW', {
                tournamentId: payload.tournament,
                typeView: 'extended'
              });

              context.commit('SET_SIZE_ODD_BUTTON', {
                tournamentId: payload.tournament,
                sizeOddsButtons: {
                  sizeOddButtonMd: 'md-2',
                  sizeOddButtonLg: 'lg-2',
                  sizeOddButtonXl: 'xl-2'
                }
              });
            }

            context.commit('SET_EVENT_DETAIL', []);
            context.commit('SET_EVENTS_DETAIL_ACTIVE', []);
            context.dispatch('removeAntepostActive');

            return;
          } else {
            context.dispatch('settings/setSnackbar', true, { root: true });
            context.dispatch(
              'settings/setSnackbarText',
              'eventsNoLongerAvailable',
              { root: true }
            );
            context.dispatch(
              'removeFromTournamentActive',
              payload.tournament + '#prematch'
            );
            return;
          }
        })
        .catch(error => {
          console.log(error);

          context.dispatch('settings/setSnackbar', true, { root: true });
          context.dispatch(
            'settings/setSnackbarText',
            'eventsNoLongerAvailable',
            { root: true }
          );
          context.dispatch(
            'removeFromTournamentActive',
            payload.tournament + '#prematch'
          );
          return;
        });
    }
  },

  async emptyPreview(context, payload) {
    context.commit('SET_PREVIEW', []);
  },

  async fetchPreviewForMarket(context, payload) {
    //todo consider also the mobile

    await axios
      .post(
        `${context.rootGetters['settings/getUrlApi']}/events/getodds/tournament/preview-v2`,
        {
          tournament: payload.tournament,
          platform: context.rootGetters['settings/getPlatformId'],
          type: payload.type,
          section: 'sport',
          market: payload.market,
          //"sport": payload.sport,
          filter: context.rootGetters['treeV2/getFilter'],
          lang: context.rootGetters['settings/getLanguage'],
          sportId: payload.sportId,
          mobilePlatform:
            payload.mobilePlatform != null ? payload.mobilePlatform : false,
          groupOddsWithSpreads:
            payload.groupOddsWithSpreads != null
              ? payload.groupOddsWithSpreads
              : false,
          groupId: payload.groupId
        },
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
          }
        }
      )
      .then(async res => {
        if (res.data.events.length > 0) {
          const onlyManager =
            context.rootGetters['settings/getPlatformId'] == 0;
          const rules = {
            manager: context.rootGetters['rules/getRulesManager'],
            skin: !onlyManager ? context.rootGetters['rules/getRulesSkin'] : [],
            lang: context.rootGetters['settings/getLanguage']
          };

          const producer = 0;

          const data_events = await eventsOddsHandler.refactorPreview(
            res.data,
            rules,
            producer,
            onlyManager,
            payload.source
          );

          context.commit('settings/SET_GAME_CONSOLE', res.data.gameConsole, {
            root: true
          });

          if (payload.mode == 'replaceFeaturedTournaments') {
            //todo consider to remove replace featuredTournaments case if not anymore used
            context.commit('REPLACE_FEATURED_TOURNAMENTS', data_events);
          } else {
            context.commit('REPLACE_PREVIEW', data_events);
          }

          //todo check if headerSign is null or [] , look when normal platform is set, what return
          const headerSign = res.data.headerSign;

          if (headerSign != null) {
            await context.dispatch(
              'marketview/updateSpreadsListAndSpreadSelected',
              {
                type: 'preview',
                headerSign: headerSign,
                tournamentId: payload.tournament,
                events: res.data.events
              },
              { root: true }
            );
          }

          if (res.data.combinedMarkets != null) {
            context.commit(
              'cart/ADD_COMBINABLE_MARKETS',
              res.data.combinedMarkets,
              { root: true }
            );
          }

          // if(payload.market == null){
          //     context.commit('UPDATE_MARKETS_ID_ACTIVE',{tournament: payload.tournament,marketId: 'mainMarket'});
          // }else{
          //     context.commit('UPDATE_MARKETS_ID_ACTIVE',{tournament: payload.tournament,marketId: payload.market});
          // }

          await context.dispatch(
            'marketview/updateMarketGroupActiveForTournament',
            {
              groupId: payload.groupId, //could be null
              tournamentId: +payload.tournament
            },
            { root: true }
          );

          context.commit('SET_PREVIEW_TYPE_VIEW', {
            tournamentId: payload.tournament,
            typeView: res.data.typeView
          });

          context.commit('SET_SIZE_ODD_BUTTON', {
            tournamentId: payload.tournament,
            sizeOddsButtons: res.data.sizeOddsButtons
          });

          context.commit('SET_EVENT_DETAIL', []);
          context.commit('SET_EVENTS_DETAIL_ACTIVE', []);
          context.dispatch('removeAntepostActive');
          return;
        } else {
          context.dispatch('settings/setSnackbar', true, { root: true });
          context.dispatch(
            'settings/setSnackbarText',
            'eventsNoLongerAvailable',
            { root: true }
          );
          // context.dispatch('removeFromTournamentActive', payload.tournament + '#prematch')

          context.commit(
            'SET_EVENTS_ARRAY_TO_SPECIFIC_TOURNAMENT_PREVIEW_EVENTS',
            {
              tournamentId: payload.tournament,
              events: {},
              events_sources: [],
              headerSign: [],
              market_header: null,
              market_subheader: null,
              markets: {},
              markets_count: 0
            }
          );

          return;
        }
      })
      .catch(error => {
        console.log(error);

        context.dispatch('settings/setSnackbar', true, { root: true });
        context.dispatch(
          'settings/setSnackbarText',
          'eventsNoLongerAvailable',
          { root: true }
        );
        // context.dispatch('removeFromTournamentActive', payload.tournament + '#prematch')
        return;
      });
  },

  async fetchAntepostPreview(context, payload) {
    if (!state.tournaments_active.includes(payload.source)) {
      context.commit('ADD_TOURNAMENTS_ACTIVE', payload.source);

      // let split = payload.source.split(':')
      let type = '';

      switch (payload.type) {
        case 'stage':
          type = 'antepostGroupOdds';
          break;
        case 'season':
          type = 'antepostSeasonOdds';
          break;
        case 'simple_tournament':
          type = 'antepostSimpleTournOdds';
          break;
      }

      await axios
        .post(
          `${context.rootGetters['settings/getUrlApi']}/events/getodds/tournament/event`,
          {
            event: payload.source,
            platform: +context.rootGetters['settings/getPlatformId'],
            type: type,
            section: 'sport',
            lang: context.rootGetters['settings/getLanguage'],
            sport: payload.sport ? payload.sport : '',
            tournament: payload.tournament ? payload.tournament : ''
          },
          {
            headers: {
              Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
            }
          }
        )
        .then(async res => {
          if (!isEmpty(res.data.events)) {
            const onlyManager =
              context.rootGetters['settings/getPlatformId'] == 0;
            const rules = {
              manager: context.rootGetters['rules/getRulesManager'],
              skin: !onlyManager
                ? context.rootGetters['rules/getRulesSkin']
                : [],
              lang: context.rootGetters['settings/getLanguage']
            };

            const producer = 3;
            const data_events = await eventsOddsHandler.refactorPreviewAntepost(
              res.data,
              rules,
              producer,
              onlyManager,
              payload.source
            );

            context.commit('ADD_PREVIEW', data_events);
          } else {
            // console.log('no events')
            // Todo no events
            const data_events = {
              tournament: {
                ...res.data.tournament[0]
              },
              message: {
                num_events: 0
              }
            };

            context.commit('ADD_PREVIEW', data_events);
          }
        });
    }
  },
  async removeFromPreview(context, payload) {
    const preview = remove(state.preview, function (tournament) {
      return tournament.source != payload.source;
    });

    context.commit('SET_PREVIEW', preview);

    const active = remove(state.tournaments_active, function (tournament) {
      return tournament != payload.source;
    });

    context.commit('SET_TOURNAMENTS_ACTIVE', active);
  },
  async removeFromTournamentActive(context, payload) {
    const tournamentsActive = filter(
      state.tournaments_active,
      function (tournamentActive) {
        return tournamentActive != payload;
      }
    );
    context.commit('SET_TOURNAMENTS_ACTIVE', tournamentsActive);
  },
  async removeAntepostActive(context, payload) {
    const active = remove(state.tournaments_active, function (tournament) {
      return !tournament.includes('#antepost');
    });

    context.commit('SET_TOURNAMENTS_ACTIVE', active);
  },
  async removeFromDetail(context, payload) {
    const detail = remove(state.events_detail, function (event) {
      return event.source != payload.source;
    });
    context.commit('SET_EVENT_DETAIL', detail);
    var active = remove(state.events_detail_active, function (event) {
      return event != payload.source;
    });
    context.commit('SET_EVENTS_DETAIL_ACTIVE', active);

    if (payload.type == 'antepost') {
      var active = remove(state.tournaments_active, function (tournament) {
        return tournament != payload.source + '#antepost';
      });

      context.commit('SET_TOURNAMENTS_ACTIVE', active);
    }
  },
  async removeFromDetailV2(context, payload) {
    /* todo uniformare come removeFromDetail, need save in tournament active : payload.source + '#antepost' */

    const detail = remove(state.events_detail, function (event) {
      return event.source != payload.source;
    });
    context.commit('SET_EVENT_DETAIL', detail);
    var active = remove(state.events_detail_active, function (event) {
      return event != payload.source;
    });
    context.commit('SET_EVENTS_DETAIL_ACTIVE', active);

    if (payload.type == 'antepost') {
      var active = remove(state.tournaments_active, function (tournament) {
        return tournament != payload.source + '#antepost';
      });

      context.commit('SET_TOURNAMENTS_ACTIVE', active);
    }
  },
  async removeFromLiveDetail(context, payload) {
    const detail = remove(state.events_live_detail, function (event) {
      return event.source != payload.source;
    });
    context.commit('SET_EVENT_LIVE_DETAIL', detail);
    const active = remove(state.events_live_detail_active, function (event) {
      return event != payload.source;
    });
    context.commit('SET_EVENTS_LIVE_DETAIL_ACTIVE', active);
  },
  async setLoadingPreview(context, payload) {
    context.commit('SET_LOADING_PREVIEW', payload.status);
  },
  async setLoadingGeneral(context, payload) {
    context.commit('SET_LOADING_GENERAL', payload.status);
  },
  async setFirstLoading(context, payload) {
    context.commit('SET_FIRST_LOADING', payload.status);
  },
  async setLoadingLive(context, payload) {
    context.commit('SET_LOADING_LIVE', payload.status);
  },
  async setLiveMode(context, payload) {
    if (payload.mode == 'preview') {
      context.commit('SET_EVENT_LIVE_DETAIL', []);
      context.commit('SET_EVENTS_LIVE_DETAIL_ACTIVE', []);
    }

    context.commit('SET_LIVE_MODE', payload.mode);
  },
  async setLoadingDetail(context, payload) {
    context.commit('SET_LOADING_DETAIL', payload.status);
  },
  async setLiveSportSelected(context, payload) {
    context.commit('SET_LIVE_SPORT_SELECTED', payload.data);
  },

  async fetchCashout(context, payload) {
    // console.log(payload);

    const request = {
      id_event:
        payload.id != undefined && payload.id != undefined
          ? payload.id
          : undefined,
      id_outcome:
        payload.outcome_id != undefined && payload.outcome_id != undefined
          ? payload.outcome_id
          : undefined,
      unique_id:
        payload.unique_id != undefined && payload.unique_id != undefined
          ? payload.unique_id
          : undefined,
      ext_id:
        payload.ext_id != undefined && payload.ext_id != undefined
          ? payload.ext_id
          : undefined
    };

    return axios
      .post(
        `${context.rootGetters['settings/getUrlApi']}/events/check-cashout`,
        request,
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
          }
        }
      )
      .then(async res => {
        // context.commit('SET_CASHOUT', res.data.result);
        // console.log(res.data)
        // console.log(console.log('requestprova', res.data.result));
        return res.data.result;
        //console.log(res)
        //context.commit('setTree', tree);
      })
      .catch(error => {
        console.log(error);
      });
  },

  async sentCashout(context, payload) {
    // console.log(payload);

    const request = {
      code:
        payload.code != undefined && payload.code != undefined
          ? payload.code
          : undefined,
      cashout:
        payload.cashout != undefined && payload.cashout != undefined
          ? payload.cashout
          : undefined
    };

    // console.log(request);
    return axios
      .post(
        `${context.rootGetters['settings/getUrlApi']}/bet/define-cashout`,
        request,
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
          }
        }
      )
      .then(async res => {
        // context.commit('SET_CASHOUT', res.data.result);
        // console.log(res.data)
        return res.data;
        //console.log(res)
        //context.commit('setTree', tree);
      })
      .catch(error => {
        console.log(error);
      });
  },
  async setDayLimit(context, payload) {
    context.commit('SET_DAY_LIMIT', payload.dayLimit);
    return;
  },
  async setDaySkip(context, payload) {
    // console.log("payload",payload)
    context.commit('SET_DAY_SKIP', payload.daySkip);
    return;
  },
  async setEventStatscore(context, payload) {
    context.commit('SET_EVENT_STATSCORE', payload);
    return;
  },
  async setPrematchEventStatscore(context, payload) {
    context.commit('SET_PREMATCH_EVENT_STATSCORE', payload);
    return;
  },

  async destroyEventLive(context, payload) {
    // console.log("payload",payload)
    context.commit('SET_EVENT_LIVE_DETAIL', []);
    context.commit('SET_EVENTS_DETAIL_ACTIVE', []);
    return;
  },

  async addOrUpdateIndexOfTabActiveForThisTournament(context, payload) {
    context.commit(
      'FIND_AND_UPDATE_PREVIEW_TABS_ACTIVE_FOR_TOURNAMENT',
      payload
    );
  },

  async setMarketsGroupsIdActiveAction(context, payload) {
    context.commit('setMarketsGroupsIdActive', payload);
  },

  async setMarketsIdActiveAction(context, payload) {
    context.commit('setMarketsIdActive', payload);
  },

  async setPreviewTabSelectedForTournamentAction(context, payload) {
    context.commit('SET_PREVIEW_TAB_SELECTED_FOR_TOURNAMENT', payload);
  },

  async setIsAFirstLoadForFeaturedTournament(context, payload) {
    context.commit('SET_IS_A_FIRST_LOAD_FOR_FEATURED_TOURNAMENT', payload);
  },

  async setViewLiveMatchTracker(context, payload) {
    console.log('setViewLiveMatchTracker action');
    console.log(payload);

    context.commit('SET_VIEW_LIVE_MATCH_TRACKER', payload);
  },

  async closePrematchEventsCards(context, payload) {
    context.commit('SET_PREVIEW', []);
    context.commit('SET_TOURNAMENTS_ACTIVE', []);
    context.commit('SET_EVENT_DETAIL', []);
    context.commit('SET_EVENTS_DETAIL_ACTIVE', []);
    context.commit('SET_PREVIEW_NEXT_EVENTS', []);
    context.commit('SET_COUNT_NEXT_EVENTS', []);
    context.commit('SET_PREVIEW_EVENTS_DAY', []);
    context.commit('SET_COUNT_EVENTS_DAY', []);
  },
  async setHideBestPlayedWidget(context, payload) {
    context.commit('SET_HIDE_BEST_PLAYED_WIDGET', payload);
  },

  async disableAndOrderOddsDefined(context, payload) {
    // console.log('[DEBUG] ORDER_ODDS_DEFINED');
    // console.log('the payload is: ')
    // console.log(payload)

    // const mock = [{
    //     "id": 3319168988,
    //     "odds": {
    //         "set": [
    //             {
    //                 "_attributes": {
    //                     "external_id": "117837450812810585",
    //                     "status": 3,
    //                     "odds": "1",
    //                     "lastUpdate": "2024-05-03T15:33:56.893Z"
    //                 },
    //                 "unique_id": "3319168988;9545715241#1.5;9576733344"
    //             },
    //             {
    //                 "_attributes": {
    //                     "external_id": "96018398512810585",
    //                     "status": 3,
    //                     "odds": "1",
    //                     "lastUpdate": "2024-05-03T15:33:56.893Z"
    //                 },
    //                 "unique_id": "3319168988;9545715241#1.5;6421647443"
    //             }
    //
    //         ]
    //     }
    // }]

    if (context.state.preview_live.length > 0) {
      forEachLodash(payload, async change => {
        //console.log('[DEBUG] SOME ODDS TO SET DEFINED FOR EVENT ID:  ' + change.id)

        const check_exists = findLodash(context.state.preview_live, event => {
          return event.events_sources.includes(change.id);
        });

        if (check_exists) {
          const check = findLodash(check_exists.events, { id: change.id });

          if (check && check.odds) {
            // IF into the store there are outcomes for this event

            // console.log('[DEBUG] FOUND EVENT... HAS ODDS ...');
            // console.log(change.odds.set)

            let outcomeDefined = false;

            try {
              forEachLodash(check.odds, async oddsGroup => {
                forEachLodash(oddsGroup.odds, outcome_to_update => {
                  const checkOdd = findLodash(change.odds.set, {
                    unique_id: outcome_to_update.unique_id
                  });

                  if (checkOdd) {
                    // console.log('*********************************** outcome found !!!! ****************************************')
                    // console.log(checkOdd)

                    outcome_to_update.active = false;
                    outcome_to_update.defined = true;
                    outcomeDefined = true;
                  }
                });
              });

              if (outcomeDefined === true) {
                // console.log('[DEBUG] FIND IF ONE EVENT NEED REORDER ');

                let reOrder = false;

                forEachLodash(check.odds, async oddsGroup => {
                  let countOddsDefined = 0;

                  const outcomeLength = oddsGroup.odds.length;

                  forEachLodash(oddsGroup.odds, outcome_to_update => {
                    if (
                      outcome_to_update &&
                      outcome_to_update.defined &&
                      outcome_to_update.defined === true
                    ) {
                      countOddsDefined = countOddsDefined + 1;
                    }
                  });

                  if (countOddsDefined === outcomeLength) {
                    //console.log('[DEBUG] FOUND MARKET GROUP WITH ALL THE OUTCOME DEFINED')
                    oddsGroup.specifierLivePreviewSort = 999; // override specifier sort
                    reOrder = true;
                  }
                });

                if (
                  reOrder === true &&
                  context.rootGetters[
                    'socket/getShiftOutcomeAlreadyDefined'
                  ] === true
                ) {
                  //console.log(' ********************* [DEBUG] RE ORDERING THE ODDS *****************')
                  check.odds = _.orderBy(
                    check.odds,
                    ['marketLivePreviewSort', 'specifierLivePreviewSort'],
                    ['asc', 'asc']
                  );
                }
              }
            } catch (e) {
              console.log(e);
            }
          }
        }
      });
    }
  },
  async printOdds(context, payload) {
    try {
      const response = await axios.post(
        `${context.rootGetters['settings/getUrlApi']}/api/print/odds`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
          },
          responseType: 'blob'
        }
      );

      // create temporary URL for the file downloaded
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      // set file name
      link.setAttribute('download', 'odds.pdf');

      // add link to DOM and simulate click
      document.body.appendChild(link);
      link.click();

      // remove the link from the DOM
      document.body.removeChild(link);

      return response; // return response for other elaboration
    } catch (error) {
      console.error(error);
    }
  },
  async printTemplate(context, payload) {
    try {
      const response = await axios.post(
        `${context.rootGetters['settings/getUrlApi']}/api/print/templates/odds`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${context.rootGetters['settings/getToken']}`
          },
          responseType: 'blob'
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

      link.setAttribute('download', 'odds_template.pdf');

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      return response;
    } catch (error) {
      console.error(error);
    }
  }
};

const mutations = {
  REPLACE_PREVIEW(state, payload) {
    // todo actually we missed the source.. returning the new filtered events, so for now I'm looking for tournament id

    const objIndex = state.preview.findIndex(
      preview => preview.tournament.id == payload.tournament.id
    );

    if (objIndex != -1) {
      const savePreview = state.preview;
      state.preview = [];
      savePreview[objIndex] = payload;
      state.preview = savePreview;
    }
  },
  REPLACE_PREVIEW_OR_ADD_IF_NOT_PRESENT(state, payload) {
    const objIndex = state.preview.findIndex(
      preview => preview.tournament.id == payload.tournament.id
    );

    if (objIndex != -1) {
      const savePreview = state.preview;
      state.preview = [];
      savePreview[objIndex] = payload;
      state.preview = savePreview;
    } else {
      state.preview = [];
      state.preview.unshift(payload);
    }
  },
  ADD_PREVIEW(state, payload) {
    // console.log(state.preview)
    state.preview.unshift(payload);
  },
  ADD_PREVIEW_REVERSE(state, payload) {
    state.preview.push(payload);
  },
  RESET_LIVE(state, payload) {
    state.live = payload;
  },
  SET_COUNT_LIVE(state, payload) {
    state.count_live = payload;
  },
  SET_COUNT_NEXT_EVENTS(state, payload) {
    state.count_next_events = payload;
  },
  SET_COUNT_EVENTS_DAY(state, payload) {
    state.count_events_day = payload;
  },
  ADD_PREVIEW_LIVE(state, payload) {
    state.preview_live.unshift(payload);
  },
  ADD_PREVIEW_NEXT_EVENTS(state, payload) {
    state.preview_next_events.push(payload);
  },
  ADD_PREVIEW_EVENTS_DAY(state, payload) {
    /*console.log(state.preview_events_day)
        console.log(payload)*/
    forEachLodash(payload, pay => {
      if (
        !findLodash(state.preview_events_day, { events: { id: pay.events.id } })
      ) {
        state.preview_events_day.push(pay);
      }
    });
    /*state.preview_events_day = [...state.preview_events_day,...payload]
        state.preview_events_day.concat(payload);
        console.log(state.preview_events_day)*/
  },
  ADD_TOURNAMENTS_ACTIVE(state, payload) {
    state.tournaments_active.unshift(payload);
  },
  SET_PREVIEW(state, payload) {
    state.preview = payload;
  },
  SET_PREVIEW_LIVE(state, payload) {
    state.preview_live = payload;
  },
  SET_PREVIEW_NEXT_EVENTS(state, payload) {
    state.preview_next_events = payload;
  },
  SET_PREVIEW_EVENTS_DAY(state, payload) {
    state.preview_events_day = payload;
  },
  SET_PREVIEW_EVENTS_BEST_PLAYED(state, payload) {
    state.preview_events_best_played = payload;
  },
  SET_COUNT_EVENTS_BEST_PLAYED(state, payload) {
    state.count_events_best_played = payload;
  },
  SET_TOURNAMENTS_ACTIVE(state, payload) {
    state.tournaments_active = payload;
  },
  SET_LOADING_PREVIEW(state, payload) {
    state.loading_preview = payload;
  },
  SET_LOADING_GENERAL(state, payload) {
    state.loading_general = payload;
  },
  SET_FIRST_LOADING(state, payload) {
    state.first_loading = payload;
  },
  SET_LOADING_LIVE(state, payload) {
    state.loading_live = payload;
  },
  SET_LOADING_DETAIL(state, payload) {
    state.loading_detail = payload;
  },
  ADD_EVENT_DETAIL(state, payload) {
    state.events_detail.unshift(payload);
  },
  SET_EVENT_DETAIL(state, payload) {
    state.events_detail = payload;
  },
  ADD_EVENT_LIVE_DETAIL(state, payload) {
    state.events_live_detail.unshift(payload);
  },
  SET_EVENT_LIVE_DETAIL(state, payload) {
    state.events_live_detail = payload;
  },
  ADD_EVENTS_DETAIL_ACTIVE(state, payload) {
    state.events_detail_active.unshift(payload);
  },
  SET_EVENTS_DETAIL_ACTIVE(state, payload) {
    state.events_detail_active = payload;
  },
  ADD_EVENTS_LIVE_DETAIL_ACTIVE(state, payload) {
    state.events_live_detail_active.unshift(payload);
  },
  SET_EVENTS_LIVE_DETAIL_ACTIVE(state, payload) {
    state.events_live_detail_active = payload;
  },
  UPDATE_ODDS_EVENT_DETAIL(state, payload) {
    const detail = findLodash(state.events_detail, {
      source: payload.event.source
    });
    detail.event.odds = payload.event.odds;
  },
  UPDATE_ODDS_EVENT_LIVE_DETAIL(state, payload) {
    const detail = findLodash(state.events_live_detail, {
      source: payload.event.source
    });
    detail.event.odds = payload.event.odds;
  },
  SET_LIVE_MODE(state, payload) {
    state.live_mode = payload;
  },
  SET_LIVE_SPORT_SELECTED(state, payload) {
    state.live_sport_selected = payload;
  },
  SET_CASHOUT(state, payload) {
    state.cashout = payload;
  },
  SET_DAY_LIMIT(state, payload) {
    state.dayLimit = payload;
  },
  SET_DAY_SKIP(state, payload) {
    state.daySkip = payload;
  },
  SET_EVENT_STATSCORE(state, payload) {
    state.event_statscore = payload;
  },
  setConfiguredGroupsMarkets(state, payload) {
    state.configuredGroupsMarkets = payload;
  },
  addGroupsMarketsObject(state, payload) {
    state.configuredGroupsMarkets.push(payload);
  },
  setMarketsGroupsIdActive(state, payload) {
    state.marketsGroupsIdActive = payload;
  },
  addMarketsGroupIdActive(state, payload) {
    state.marketsGroupsIdActive.push(payload);
  },
  replaceMarketGroupIdActive(state, payload) {
    const objIndex = state.marketsGroupsIdActive.findIndex(
      marketGroupInfo => marketGroupInfo.tournamentId == payload.tournamentId
    );

    if (objIndex != -1) {
      state.marketsGroupsIdActive[objIndex] = payload;
    }
  },
  setMarketsIdActive(state, payload) {
    state.marketsIdActive = payload;
  },
  addMarketIdActive(state, payload) {
    state.marketsIdActive.push(payload);
  },
  replaceMarketIdActive(state, payload) {
    const objIndex = state.marketsIdActive.findIndex(
      marketIdActive => marketIdActive.tournamentId == payload.tournamentId
    );
    if (objIndex != -1) {
      state.marketsIdActive[objIndex] = payload;
    }
  },
  SET_PREMATCH_EVENT_STATSCORE(state, payload) {
    state.prematch_statscore = payload;
  },
  SET_ODDS_TYPE(state, payload) {
    // state.odds_type = { ...state.odds_type, newProp: payload }
    state.odds_type = payload;
  },
  SET_PREVIEW_TYPE_VIEW(state, payload) {
    const marketIndex = state.marketsGroupsIdActive.findIndex(
      marketGroupActive => {
        return marketGroupActive.tournamentId == payload.tournamentId;
      }
    );

    if (marketIndex != -1) {
      state.marketsGroupsIdActive[marketIndex].typeView = payload.typeView;
    }
  },
  SET_SIZE_ODD_BUTTON(state, payload) {
    const marketIndex = state.marketsGroupsIdActive.findIndex(
      marketGroupActive => {
        return marketGroupActive.tournamentId == payload.tournamentId;
      }
    );

    if (marketIndex != -1) {
      state.marketsGroupsIdActive[marketIndex].sizeOddsButtons =
        payload.sizeOddsButtons;
    }
  },
  SET_PREVIEW_TAB_SELECTED_FOR_TOURNAMENT(state, payload) {
    state.previewTabsSelectedForTournament = payload;
  },
  FIND_AND_UPDATE_PREVIEW_TABS_ACTIVE_FOR_TOURNAMENT(state, payload) {
    const indexOfTabActiveForThisTournament =
      state.previewTabsSelectedForTournament.findIndex(
        tab_active => tab_active.tournamentId == payload.tournamentId
      );

    if (indexOfTabActiveForThisTournament == -1) {
      state.previewTabsSelectedForTournament.push({
        tournamentId: payload.tournamentId,
        index: payload.index,
        marketId: payload.marketId
      });
    } else {
      state.previewTabsSelectedForTournament[
        indexOfTabActiveForThisTournament
      ] = {
        tournamentId: payload.tournamentId,
        index: payload.index,
        marketId: payload.marketId
      };
    }
  },
  SET_EVENTS_ARRAY_TO_SPECIFIC_TOURNAMENT_PREVIEW_EVENTS(state, payload) {
    const tournamentId = payload.tournamentId;

    const indexOfTournament = state.preview.findIndex(
      preview =>
        preview.tournament != null && preview.tournament.id == tournamentId
    );

    if (indexOfTournament != -1) {
      state.preview[indexOfTournament].events = payload.events;
      state.preview[indexOfTournament].events_sources = payload.events_sources;
      state.preview[indexOfTournament].headerSign = payload.headerSign;
      state.preview[indexOfTournament].market_header = payload.market_header;
      state.preview[indexOfTournament].market_subheader =
        payload.market_subheader;
      state.preview[indexOfTournament].markets = payload.markets;
      state.preview[indexOfTournament].markets_count = payload.markets_count;
    }
  },
  SET_NEXT_EVENT_MODULE_SELECTED(state, payload) {
    state.nextEventModuleSelected = payload;
  },
  SET_MARKETS_GROUPS_DETAIL_PREMATCH(state, payload) {
    state.marketsGroupsDetailPrematch = payload;
  },

  SET_MARKETS_GROUPS_DETAIL_LIVE(state, payload) {
    state.marketsGroupsDetailLive = payload;
  },

  SET_FEATURED_TOURNAMENTS(state, payload) {
    state.featuredTournaments = payload;
  },

  ADD_FEATURED_TOURNAMENTS(state, payload) {
    state.featuredTournaments.unshift(payload);
  },

  REPLACE_FEATURED_TOURNAMENTS(state, payload) {
    // todo actually we missed the source.. returning the new filtered events, so for now I'm looking for tournament id

    const objIndex = state.featuredTournaments.findIndex(
      featuredT => featuredT.tournament.id == payload.tournament.id
    );

    if (objIndex != -1) {
      const savePreview = state.featuredTournaments;
      state.featuredTournaments = [];
      savePreview[objIndex] = payload;
      state.featuredTournaments = savePreview;
    } else {
      state.featuredTournaments.push(payload);
    }
  },

  SET_FEATURED_TOURNAMENTS_SOURCES_ACTIVE(state, payload) {
    state.featuredTournamentsSourcesActive = payload;
  },

  ADD_FEATURED_TOURNAMENT_SOURCE_INFO(state, payload) {
    state.featuredTournamentsSourcesActive.push(payload);
  },

  REMOVE_FEATURED_TOURNAMENTS_SOURCES_FROM_TOURNAMENT_ACTIVES(state, payload) {
    //console.log('sono attivi i seguenti source tornei: ', state.tournaments_active)

    state.tournaments_active = state.tournaments_active.filter(
      tournamentSource => {
        return !state.featuredTournamentsSourcesActive.includes(
          tournamentSource
        );
      }
    );

    state.featuredTournamentsSourcesActive = [];
  },

  SET_IS_A_FIRST_LOAD_FOR_FEATURED_TOURNAMENT(state, payload) {
    state.isFirstLoadForFeaturedTournament = payload;
  },
  SET_VIEW_LIVE_MATCH_TRACKER(state, payload) {
    state.viewLiveMatchTracker = payload;
  },

  SET_HIDE_BEST_PLAYED_WIDGET(state, payload) {
    state.hideBestPlayedWidget = payload;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
